/**
 * ================================================================
 * Bisou Rivage — bisou-tshirt.js
 * ================================================================
 * Le selecteur de la fiche t-shirt, ses deux scenes et ses deux panneaux.
 * Ce fichier ne touche NI aux tirages, NI au vote, NI au panier : il pose des
 * classes, choisit une variante, et laisse le theme faire le reste.
 *
 * POURQUOI PAS bisou-variant-ui.js ? Parce que ce fichier-la raisonne en
 * formats de tirage et en finitions de cadre : il cherche « a2 », « cadre »,
 * « chene » dans le TITRE de la variante (findVariantId, ligne 108) et
 * n'ouvrirait jamais un « M / Blanc ». Ici on ne devine rien : les options
 * sont reperees par leur INDEX, pose par le Liquid, et compare valeur a
 * valeur.
 *
 * LE CHEMIN VERS LE PANIER EST CELUI DU THEME, pas un raccourci :
 *   1. on pose la valeur exacte sur chaque <select> de <variant-selects> ;
 *   2. on verifie que les selects designent bien la variante visee ;
 *   3. on emet `change` — product-info.js re-rend le prix et le bouton
 *      depuis le SERVEUR.
 * On double par un ecrit direct dans input[name="id"] : sur iPad Safari un
 * <select> completement cache peut ne pas propager l'evenement, et le panier
 * doit recevoir la bonne variante meme quand l'affichage a rate.
 *
 * DEUX PANNEAUX, UN SEUL FOND NOIR.
 * assets/bisou-fiche.js tient celui de la precommande : il pose
 * `.rv5-edition-on` sur le bloc gris quand on clique un `.rv5-edition-tag--gold`.
 * Celui du guide des tailles est a nous et pose `.brt-panel-on`. Les deux ne
 * peuvent pas etre ouverts ensemble — deux textes sur le meme noir seraient
 * illisibles — et c'est ce fichier qui ferme l'un quand l'autre s'ouvre.
 * ================================================================
 */
(function () {
  'use strict';

  var CFG = window.BISOU_TSHIRT_CFG;
  if (!CFG || !CFG.sectionId) return;

  var root = document.getElementById('TshirtProduct-' + CFG.sectionId);
  if (!root) return;

  var L = CFG.lang || {};
  var OPT = CFG.opt || {};
  var VARIANTS = CFG.variants || [];

  /** Les chaines des locales portent {{ d }}, {{ h }}, {{ date }}… */
  function fill(str, vars) {
    if (!str) return '';
    if (!vars) return str;
    return str.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m;
    });
  }

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  /** Un defilement lance par le code glisse ; en mouvement reduit, il saute. */
  function glisse() {
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'auto'; } catch (e) {}
    return 'smooth';
  }

  /* ══════════════════ 1. L'ETAT, ET LA VARIANTE QU'IL DESIGNE ══════════════════ */

  var state = {
    mode: CFG.init ? CFG.init.mode : null,
    size: CFG.init ? CFG.init.size : null,
    color: CFG.init ? CFG.init.color : null
  };

  /** Une variante correspond-elle a un etat ? Une option absente du produit
   *  (index null) ne contraint rien : un produit sans couleur se choisit avec
   *  une taille seule. */
  function matches(v, st) {
    if (OPT.mode != null && st.mode != null && v.o[OPT.mode] !== st.mode) return false;
    if (OPT.size != null && st.size != null && v.o[OPT.size] !== st.size) return false;
    if (OPT.color != null && st.color != null && v.o[OPT.color] !== st.color) return false;
    return true;
  }

  function findVariant(st) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (matches(VARIANTS[i], st)) return VARIANTS[i];
    }
    return null;
  }

  /** Existe-t-il UNE variante disponible pour cet etat partiel ? C'est ce qui
   *  decide si une taille se barre ou si une pastille se raye. */
  function anyAvailable(partial) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].a && matches(VARIANTS[i], partial)) return true;
    }
    return false;
  }

  /** La premiere valeur d'option disponible dans le contexte donne. Sert a
   *  rattraper un choix devenu impossible : on change de taille, la couleur
   *  choisie n'existe pas dans cette taille, on prend la premiere qui existe
   *  plutot que de laisser un bouton « epuise » selectionne. */
  function firstAvailableValue(index, partial) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (!VARIANTS[i].a) continue;
      if (matches(VARIANTS[i], partial)) return VARIANTS[i].o[index];
    }
    return null;
  }

  /* ══════════════════ 2. POSER LA VARIANTE SUR LE THEME ══════════════════ */

  /** <variant-selects> est REMPLACE a chaque mise a jour par product-info.js
   *  (updateOptionValues → HTMLUpdateUtility.viewTransition). On ne garde donc
   *  jamais de reference : on requete a chaque fois. */
  function selects() {
    var vs = root.querySelector('variant-selects');
    return vs ? Array.prototype.slice.call(vs.querySelectorAll('select')) : [];
  }

  /** POSER LA VALEUR, ET L'ATTRIBUT AVEC.
   *
   *  Le theme ne lit pas `select.value`. `VariantSelects.selectedOptionValues`
   *  (assets/global.js) fait
   *  `querySelectorAll('select option[selected]')` : il lit l'ATTRIBUT HTML.
   *  Et `updateSelectionMetadata` ne recale cet attribut que sur le select qui
   *  a EMIS le `change` — or on n'en emet qu'un seul, sur le dernier, pour
   *  n'envoyer qu'une requete.
   *
   *  Consequence, avant le 02/09 : cliquer « En stock » affichait bien 49 €,
   *  puis product-info.js relisait les attributs — restes sur Precommande pour
   *  les deux premiers selects —, rechargeait la variante a 35 € et
   *  reecrivait SON identifiant dans le formulaire. Le panier partait en
   *  precommande.
   *
   *  On synchronise donc l'attribut ici, sur les trois selects. Et TOUJOURS
   *  exactement une option le porte : `updateSelectionMetadata` fait un
   *  `.find(...).removeAttribute(...)` sans garde, il jetterait sur zero. */
  function setSelectValue(sel, value) {
    var opts = sel.querySelectorAll('option');
    var cible = null;
    for (var i = 0; i < opts.length; i++) {
      var brut = opts[i].value;
      var texte = (opts[i].textContent || '').trim();
      if (brut === value || texte === value) { cible = opts[i]; break; }
    }
    if (!cible) return false;
    if (sel.value !== cible.value) sel.value = cible.value;
    for (var j = 0; j < opts.length; j++) {
      if (opts[j] === cible) opts[j].setAttribute('selected', 'selected');
      else opts[j].removeAttribute('selected');
    }
    return true;
  }

  /** La variante que les selects designent A CET INSTANT. C'est la
   *  verification avant envoi : si elle ne vaut pas celle qu'on visait, on ne
   *  dispatche rien plutot que d'envoyer au serveur une combinaison qu'on n'a
   *  pas voulue. */
  function variantFromSelects(sels) {
    var courant = sels.map(function (s) { return s.value; });
    for (var v = 0; v < VARIANTS.length; v++) {
      var o = VARIANTS[v].o;
      if (!o || o.length !== courant.length) continue;
      var pareil = true;
      for (var k = 0; k < o.length; k++) {
        if (o[k] !== courant[k]) { pareil = false; break; }
      }
      if (pareil) return VARIANTS[v].id;
    }
    return null;
  }

  /** Ecrit l'identifiant de variante dans le formulaire. Le champ n'est
   *  reactive QUE si la variante est achetable : Shopify desactive ce champ
   *  cote serveur sur un produit epuise, et le rouvrir de force ferait partir
   *  au panier une taille qui n'existe plus. Le bouton reste desactive de
   *  toute facon, mais un formulaire qui ment est un formulaire qui finira
   *  par etre soumis. */
  function writeFormVariantId(id, dispo) {
    var forms = root.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('input[name="id"]');
      if (!input) continue;
      if (dispo) {
        input.disabled = false;
        input.removeAttribute('disabled');
      }
      input.value = id;
      input.setAttribute('value', id);
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    } catch (e) { /* URL indisponible : sans effet sur le panier */ }
  }

  var pushing = false;

  function pushVariant() {
    var v = findVariant(state);
    if (!v) return;

    writeFormVariantId(v.id, v.a);

    var sels = selects();
    if (!sels.length) return;

    var ok = true;
    if (OPT.mode != null && !setSelectValue(sels[OPT.mode], state.mode)) ok = false;
    if (OPT.size != null && !setSelectValue(sels[OPT.size], state.size)) ok = false;
    if (OPT.color != null && !setSelectValue(sels[OPT.color], state.color)) ok = false;
    if (!ok) return;

    if (variantFromSelects(sels) !== v.id) return;

    pushing = true;
    sels[sels.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () { pushing = false; }, 200);
  }

  /* ══════════════════ 3. LES DEUX LIGNES D'EXPEDITION ══════════════════ */

  var buyRows = $$('[data-brt-mode]');

  function refreshBuyRows() {
    buyRows.forEach(function (row) {
      var mode = row.getAttribute('data-brt-mode');
      var synthetic = row.hasAttribute('data-brt-synthetic');
      var usable = !synthetic && (OPT.mode == null || anyAvailable({ mode: mode }));
      row.classList.toggle('is-disabled', !usable);
      row.classList.toggle('active', usable && (OPT.mode == null || mode === state.mode));
      row.setAttribute('aria-disabled', usable ? 'false' : 'true');
    });
  }

  /** Le panneau ne s'ouvre TOUT SEUL qu'une fois, au premier choix de la
   *  precommande. Il faut seduire, pas harceler : au deuxieme clic la ligne ne
   *  fait plus que choisir, et « Pourquoi precommander ? » reste en face du
   *  libelle pour qui veut relire. */
  var panelAutoDone = false;

  buyRows.forEach(function (row) {
    row.addEventListener('click', function () {
      if (row.classList.contains('is-disabled')) return;
      var mode = row.getAttribute('data-brt-mode');
      var isPreorder = row.hasAttribute('data-brt-preorder');

      /* DEJA CHOISIE : le clic deplie, le suivant replie (Max, 05/09 : « si on
         le reclique ca le deplie et si on clique a nouveau ca le replie »).
         Le chevron sait faire, on passe par lui. */
      if (OPT.mode == null || mode === state.mode) {
        var more = row.querySelector('[data-brt-more]');
        if (more) more.click();
        return;
      }

      if (OPT.mode != null && mode !== state.mode) {
        state.mode = mode;
        /* Changer de mode peut rendre le couple taille/couleur impossible :
           on le rattrape avant de pousser, sinon on enverrait au panier une
           combinaison qui n'existe pas. */
        if (OPT.size != null && !anyAvailable({ mode: mode, size: state.size })) {
          var s = firstAvailableValue(OPT.size, { mode: mode });
          if (s) state.size = s;
        }
        if (OPT.color != null && !anyAvailable({ mode: mode, size: state.size, color: state.color })) {
          var c = firstAvailableValue(OPT.color, { mode: mode, size: state.size });
          if (c) state.color = c;
        }
        refreshAll();
        pushVariant();
        showShotForColor();
      }

      if (isPreorder && CFG.panelOnSelect && !panelAutoDone) {
        panelAutoDone = true;
        var opener = $('.brt-info');
        if (opener && opener.getAttribute('aria-expanded') !== 'true') opener.click();
      }
    });

    /* Une ligne est un `role="button"` : au clavier, Entree et Espace doivent
       faire ce que fait la souris. */
    row.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      row.click();
    });
  });

  /* ══════════════════ 4. TAILLES ET COULEURS ══════════════════ */

  var sizeBtns = $$('[data-brt-size]');
  var colorBtns = $$('[data-brt-color]');
  var colorLabel = $('[data-brt-color-label]');

  function refreshSizes() {
    sizeBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-brt-size');
      var out = !anyAvailable({ mode: state.mode, size: val });
      btn.classList.toggle('is-out', out);
      btn.classList.toggle('is-active', val === state.size);
      btn.setAttribute('aria-pressed', val === state.size ? 'true' : 'false');
      btn.title = out ? (L.sizeUnavailable || '') : '';
    });
  }

  /** Les pastilles portent `active`, la classe des tirages : tout leur dessin
   *  — le rond, le lisere noir du choix courant — vient de
   *  bisou-variant-ui.css, on ne le redessine pas. */
  function refreshColors() {
    colorBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-brt-color');
      var out = !anyAvailable({ mode: state.mode, size: state.size, color: val });
      btn.classList.toggle('is-out', out);
      btn.classList.toggle('active', val === state.color);
      btn.setAttribute('aria-pressed', val === state.color ? 'true' : 'false');
    });
    if (colorLabel) colorLabel.textContent = state.color || '';
  }

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-out')) return;
      state.size = btn.getAttribute('data-brt-size');
      /* La couleur choisie n'existe peut-etre pas dans cette taille : on la
         remplace plutot que de laisser un choix impossible a l'ecran. */
      if (OPT.color != null && !anyAvailable({ mode: state.mode, size: state.size, color: state.color })) {
        var c = firstAvailableValue(OPT.color, { mode: state.mode, size: state.size });
        if (c) state.color = c;
      }
      refreshAll();
      pushVariant();
      showShotForColor();
    });
  });

  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-out')) return;
      state.color = btn.getAttribute('data-brt-color');
      refreshAll();
      pushVariant();
      showShotForColor();
    });
  });

  /* ══════════════════ 5. QUANTITE ══════════════════ */

  (function quantity() {
    var input = $('[data-brt-qty-input]');
    if (!input) return;
    var minus = $('[data-brt-qty="minus"]');
    var plus = $('[data-brt-qty="plus"]');

    function clamp() {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      input.value = n;
      if (minus) minus.disabled = n <= 1;
      if (plus) plus.disabled = n >= 99;
    }

    if (minus) minus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) - 1;
      clamp();
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      clamp();
    });
    input.addEventListener('change', clamp);
    clamp();
  })();

  /* ══════════════════ 6. LES PACKSHOTS ══════════════════ */

  var shots = $$('.brt-shot');
  var dots = $$('.brt-dot');
  var prevBtn = $('[data-brt-shot="prev"]');
  var nextBtn = $('[data-brt-shot="next"]');
  var shotIndex = 0;
  var dockRefresh = null;
  var scrubNow = null;
  /* Partages entre le survol devant/dos et le scrub : ou en est le morphing
     (0 = scene 1 posee, 1 = packshot fondu dans la paire), et comment
     annuler un survol en cours quand la vue change sous la souris. */
  var morphQ = 0;
  var clearPeek = null;
  /* Sur telephone, la galerie est une piste a glisser : cette media query
     departage les deux mecaniques — fondu sur ordinateur, glissement au
     doigt en dessous de 900 px. */
  var mqMobile = null;
  try { mqMobile = window.matchMedia('(max-width: 899px)'); } catch (e) {}
  /* Pendant un defilement programme de la piste (clic sur un point, choix
     d'une couleur), les evenements scroll qui en decoulent ne doivent pas
     etre relus comme un geste du visiteur. */
  var snapGuard = 0;

  /** LA GALERIE NE MONTRE QUE LA COULEUR CHOISIE.
   *  Shopify n'attache qu'UNE image par variante : la deuxieme vue d'une
   *  couleur reste orpheline, et le Liquid la rattache par son texte
   *  alternatif ou son nom de fichier. Ici on ne garde que les photos de la
   *  couleur courante — plus celles dont on ne sait rien, qu'on ne cache
   *  jamais. Le blanc et le noir ne se melangent plus dans le meme
   *  carrousel. */
  function visibleShots() {
    if (!state.color) return shots;
    var keep = shots.filter(function (s) {
      var c = s.getAttribute('data-brt-shot-color');
      return !c || c === state.color;
    });
    return keep.length ? keep : shots;
  }

  function showShot(i, fromScroll) {
    var list = visibleShots();
    if (!list.length) return;
    if (i < 0) i = 0;
    if (i > list.length - 1) i = list.length - 1;
    shotIndex = i;
    if (clearPeek) clearPeek();
    /* `is-off` : les photos des AUTRES couleurs. Sur ordinateur elles sont
       deja invisibles (opacity) ; sur telephone la piste a glisser doit les
       sortir du flux, sinon on glisse d'un blanc a un noir. */
    shots.forEach(function (s) {
      s.classList.remove('is-active');
      s.classList.toggle('is-off', list.indexOf(s) === -1);
    });
    list[i].classList.add('is-active');
    /* Telephone : on amene la piste sur la vue demandee — sauf si c'est le
       glissement lui-meme qui vient de nous dire ou on est. */
    if (!fromScroll && mqMobile && mqMobile.matches) {
      var boxEl = $('.brt-shots');
      if (boxEl) {
        snapGuard = Date.now() + 700;
        boxEl.scrollTo({ left: list[i].offsetLeft, behavior: glisse() });
      }
    }
    /* Autant de pastilles que de photos VISIBLES : une pastille qui ne mene
       nulle part est pire que pas de pastille. */
    dots.forEach(function (d, k) {
      d.hidden = k >= list.length;
      d.classList.toggle('is-active', k === i);
    });
    if (prevBtn) prevBtn.disabled = i === 0;
    if (nextBtn) nextBtn.disabled = i === list.length - 1;
    buildPair();
    if (dockRefresh) dockRefresh();
    if (scrubNow) scrubNow();
  }

  /* ── LA PAIRE DE LA SCENE 2 ──
     La scene 2 ouvre sur les deux vues de la couleur en cours, en petit :
     celle qu'on regardait en scene 1 D'ABORD, l'autre a sa droite
     (Max, 02/09 : « si on est sur l'image 1, elle se place a gauche et fait
     apparaitre la 2 a sa droite, et inversement »). Reconstruite a chaque
     changement de vue ou de couleur — deux clones d'<img>, rien de plus. */
  function buildPair() {
    var pair = $('[data-brt-pair]');
    if (!pair) return;
    var vis = visibleShots();
    var act = vis[shotIndex] || vis[0];
    if (!act) return;
    var ordered = [act].concat(vis.filter(function (s) { return s !== act; })).slice(0, 2);
    pair.innerHTML = '';
    ordered.forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      var clone = img.cloneNode(false);
      clone.className = 'brt-pair__img';
      clone.removeAttribute('sizes');
      clone.loading = 'lazy';
      pair.appendChild(clone);
    });
  }

  /** Au changement de couleur, on repart de la premiere photo de cette
   *  couleur : c'est ce que le client attend en cliquant sur « noir ». */
  function showShotForColor() {
    showShot(0);
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { showShot(shotIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showShot(shotIndex + 1); });
  dots.forEach(function (d, k) {
    d.addEventListener('click', function () { showShot(k); });
  });
  if (shots.length) showShot(0);

  /* ── LE GLISSEMENT DE LA GALERIE, SUR TELEPHONE ──
     La piste se prend au doigt (scroll-snap en CSS) ; ici on ne fait que
     RELIRE ou elle s'est posee pour tenir les points et la paire a jour.
     Le garde-fou temporel ignore les scrolls que showShot a lui-meme
     provoques. */
  (function swipe() {
    var boxEl = $('.brt-shots');
    if (!boxEl || !mqMobile) return;
    var raf = null;
    boxEl.addEventListener('scroll', function () {
      if (!mqMobile.matches || raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (Date.now() < snapGuard) return;
        var w = boxEl.clientWidth;
        if (!w) return;
        var list = visibleShots();
        var idx = Math.max(0, Math.min(list.length - 1, Math.round(boxEl.scrollLeft / w)));
        if (idx !== shotIndex) showShot(idx, true);
      });
    }, { passive: true });
  })();

  /* ── AGRANDIR ──
     bisou-fiche.js a bien un bouton « agrandir », mais il cherche
     `.product__media-item.is-active` : cette galerie n'en a pas, et son repli
     ouvrirait la PREMIERE photo au lieu de celle qu'on regarde. D'ou
     `data-brt-expand` plutot que `data-rv5-expand` — son gestionnaire ne se
     declenche jamais ici, et celui-ci ouvre la bonne. Le modal, le focus et
     la fermeture restent ceux du theme. */
  function openActiveShot() {
    var vis = visibleShots();
    var active = vis[shotIndex] || vis[0];
    var trigger = active && active.querySelector('.product__media-toggle');
    if (trigger) trigger.click();
  }

  var expandBtn = $('[data-brt-expand]');
  if (expandBtn) {
    expandBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openActiveShot();
    });
  }

  /* Le clic sur le vetement ouvre aussi le plein ecran, sur ordinateur.
     C'est la figure CLIQUEE qui s'ouvre, pas l'active : pendant le survol
     devant/dos, ce qu'on voit est l'autre vue — c'est elle qu'on agrandit. */
  root.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var img = e.target.closest('.brt-shot img');
    if (!img) return;
    var large = false;
    try { large = window.matchMedia('(min-width: 900px)').matches; } catch (err) {}
    if (!large) return;
    var fig = e.target.closest('.brt-shot');
    var trigger = fig && fig.querySelector('.product__media-toggle');
    if (trigger) trigger.click();
    else openActiveShot();
  });

  /* ── LE SURVOL DEVANT/DOS ──
     La souris entre sur le packshot : l'AUTRE vue de la couleur en cours
     apparait en fondu simple — devant/derriere sans cliquer (Max, 02/09
     soir). La souris sort : retour. Rien ne change dans l'etat — ni
     pastilles, ni fleches — c'est un apercu, pas une navigation. Souris
     seulement, et jamais pendant le morphing ni sous un panneau noir. */
  (function peek() {
    var stage = $('.brt-stage');
    if (!stage || shots.length < 2) return;
    var mq = null;
    try { mq = window.matchMedia('(hover: hover) and (min-width: 900px)'); } catch (e) { return; }
    var shotsBox = $('.brt-shots');
    var cur = null;

    clearPeek = function () {
      if (!cur) return;
      cur.classList.remove('is-peek');
      if (shotsBox) shotsBox.classList.remove('is-peeking');
      cur = null;
    };

    stage.addEventListener('mouseenter', function () {
      if (!mq.matches || morphQ > 0.05) return;
      var wrapEl = $('.product__media-wrapper');
      if (wrapEl && (wrapEl.classList.contains('rv5-edition-on') || wrapEl.classList.contains('brt-panel-on'))) return;
      /* Le survol ne concerne que les PACKSHOTS : devant montre le dos, le
         dos montre le devant (Max, 02/09 nuit : « en fonction de ce qui est
         select »). Sur une photo portee, il ne se passe rien. */
      var vis = visibleShots();
      var packs = vis.filter(function (s) { return s.getAttribute('data-brt-shot-color'); });
      var act = vis[shotIndex];
      var k = packs.indexOf(act);
      if (k === -1 || packs.length < 2) return;
      cur = packs[(k + 1) % packs.length];
      cur.classList.add('is-peek');
      if (shotsBox) shotsBox.classList.add('is-peeking');
    });

    stage.addEventListener('mouseleave', clearPeek);
  })();

  /* ── LA FLECHE DE RETOUR ──
     Elle revient a la page precedente quand la visite en a une, et laisse son
     `href` de repli agir sinon. Arriver par un lien partage ne doit pas mener
     a un bouton mort. */
  var backLink = $('[data-brt-back]');
  if (backLink) {
    backLink.addEventListener('click', function (e) {
      /* Sur telephone, le fil d'Ariane RENVOIE A L'ACCUEIL (Max, 02/09
         nuit) — pas a la page precedente, qui peut etre un reseau social. */
      if (mqMobile && mqMobile.matches) {
        e.preventDefault();
        /* 25/10 (site-anglais) : l'accueil de la langue de la page (« /en/ »), pas l'accueil francais. */
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        return;
      }
      if (window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  /* ══════════════════ 7. LES DEUX SCENES ══════════════════ */

  function scene1() { return $('.brt-scene--shot'); }

  (function scenes() {
    var list = $$('.brt-scene');
    var navDots = $$('.brt-scene-dot');
    if (list.length < 2 || navDots.length < 2) return;
    /* Les cinq billes ont leur pilote, sceneNav (8 bis b) : ce rail a trois
       points ne doit plus les allumer ni les faire defiler (25/10). */
    if ($('[data-brt-nav]')) return;

    /* Le rail compte TROIS points quand la fiche porte un recit : scene 1,
       scene 2, recit (Max, 02/09 : « ajoute les points sur les cotes »). */
    var story = $('.brt-b');
    var targets = list.slice();
    if (story && navDots.length > 2) targets.push(story);

    navDots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (targets[i]) targets[i].scrollIntoView({ behavior: glisse(), block: 'start' });
      });
    });

    if (typeof IntersectionObserver === 'undefined') return;

    function activate(i) {
      navDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }

    /* Le seuil est haut (55 %) : une scene ne devient « celle qu'on regarde »
       que lorsqu'elle occupe plus de la moitie de l'ecran. Sans ca les deux
       pastilles clignoteraient pendant tout le passage de l'une a l'autre. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var i = list.indexOf(en.target);
        if (i >= 0) activate(i);
      });
    }, { threshold: 0.55 });
    list.forEach(function (s) { io.observe(s); });

    /* Le recit est haut de plusieurs ecrans : un seuil de ratio n'y suffit
       pas. On observe son PREMIER chapitre — il entre, le troisieme point
       s'allume ; il ressort par le bas de l'ecran, on est revenu a la
       scene 2. */
    if (story && navDots[2]) {
      var premier = story.querySelector('.brt-b__chapter') || story;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) activate(2);
          else if (en.boundingClientRect.top > 0) activate(1);
        });
      }, { threshold: 0.2 }).observe(premier);
    }

    navDots[0].classList.add('is-active');
  })();

  /* ══════════════════ 7 ter. LE RETOUR AU T-SHIRT ══════════════════
     Au bout du recit (B), un clic remonte tout en haut — la fiche, telle
     qu'on est arrive dessus. {Max, 02/09} */
  (function backToTop() {
    /* Deux declencheurs : la fleche en haut a droite de la scene 2, et le
       lien au bout du recit. Meme geste : tout en haut, etat d'arrivee. */
    var btns = $$('[data-brt-top]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: glisse() });
      });
    });
  })();

  /* ══════════════════ 8. LA FRISE, POSEE DANS LE FLUX ══════════════════
     PLUS AUCUN COUPLAGE AU SCROLL (Max, 02/09 nuit : « j'aime pas le
     scroll qui defile les images ») : la frise est une bande posee dans la
     page, on la traverse en defilant normalement. Elle se PARCOURT a la
     souris :

       · pres d'un bord, elle defile toute seule, lentement — d'autant plus
         vite qu'on approche du bord, et sans zoom de carte pendant ce
         geste (is-edge) ;
       · les fleches du dock, en zone frise, avancent d'une vignette avec
         un amorti.

     En boucle infinie quand la copie suffit a couvrir l'ecran (le decalage
     se replie modulo une serie) ; bornee sinon. Telephone : rien de tout
     ca, la piste se prend au doigt. */
  /* IL Y A DESORMAIS PLUSIEURS BANDES (Max, 02/09 : « on va ajouter une
     deuxieme frise apres La matiere / Ce que vous recevez »). Le moteur
     n'est donc plus une IIFE mais une FONCTION, montee une fois par bande.

     `frises` les garde toutes. `friseEl`, `friseBox` et `friseTrack`
     designent la PREMIERE : elle seule sert de cible de scroll (pastilles
     de scene, bascule zone 2 <-> zone 3) et de repli si `frises` est vide.
     Le dock de fleches, lui, ne privilegie plus la premiere depuis le
     04/09 : `zone()` dans le bloc « dock » plus bas designe a chaque
     rafraichissement LA frise sous la ligne de mi-hauteur, quelle qu'elle
     soit — necessaire des qu'il y en a deux. Le gel et le fondu de bord
     s'appliquent a toutes, dans tous les cas. */
  var frises = [];
  var friseEl = null;
  var friseBox = null;
  var friseTrack = null;
  /* LA FRISE SE FIGE (Max, 02/09 : « lorsqu'une image de la frise est
     cliquee, elle se stoppe et ne roule pas en fond »). La visionneuse pose
     ce verrou a l'ouverture et le leve a la fermeture. */
  var friseFreeze = null;

  function monteFrise(friseEl, friseBox, friseTrack) {
    /* Vrai pendant l'instant qui suit un drag : le clic qui conclut le geste
       ne doit pas ouvrir la visionneuse. */
    var friseMoved = false;

    var mq = null;
    var mqReduce = null;
    try {
      mq = window.matchMedia('(min-width: 900px)');
      mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch (e) { return null; }

    /* ── LE MOTEUR DES AVIS, A L'IDENTIQUE (Max, 02/09 nuit : « exactement
       comme les avis en bas de la page d'accueil ») ── derive dolce toute
       seule, pause au survol, se prend a la main (drag pointeur), fleches
       en nudge — et boucle par repli quand le defilement depasse la
       largeur d'une serie. Le tout sur scrollLeft, comme la-bas. */
    var serie = 0;

    /* UN PAS = UNE COLONNE, pas une carte. Sur telephone la piste est une
       grille a deux rangees : deux cartes voisines peuvent partager la meme
       abscisse, et l'ancien calcul rendait alors zero. On avance donc
       jusqu'a la premiere carte qui a vraiment change de colonne. */
    function pas() {
      var it = friseTrack.querySelectorAll('.brt-album__item');
      for (var i = 1; i < it.length; i++) {
        var d = it[i].offsetLeft - it[0].offsetLeft;
        if (d > 1) return d;
      }
      return Math.round(friseBox.clientWidth * 0.6) || 300;
    }

    /* LA LARGEUR D'UNE SERIE = l'abscisse de la PREMIERE CARTE DE LA COPIE.
       Elle se compte en enfants directs de la piste — la copie, elle, vit
       dans .brt-album__clone. L'ancienne moitie d'effectif tombait juste
       tant que la piste etait une seule rangee ; en deux rangees elle
       designait une carte au milieu de la serie. */
    /* LES ABSCISSES DES CARTES, MESUREES UNE FOIS. On passe par la boite
       reelle et non par `offsetLeft` : sur telephone la rangee du bas porte
       un `transform`, qui fait d'elle le parent de reference de ses propres
       cartes — `offsetLeft` y compterait depuis la rangee, pas depuis la
       piste. La boite, elle, ne ment jamais. */
    var cartes = [];
    var ZONE = 150;

    function mesurerCartes() {
      var it = friseTrack.querySelectorAll('.brt-album__item');
      var boite = friseBox.getBoundingClientRect();
      var base = friseBox.scrollLeft;
      cartes = [];
      for (var i = 0; i < it.length; i++) {
        var r = it[i].getBoundingClientRect();
        if (!r.width) continue;
        var g = r.left - boite.left + base;
        cartes.push({ el: it[i], g: g, d: g + r.width, o: null });
      }
    }

    /* ── ELLES ARRIVENT, ELLES S'EN VONT (Max, 02/09) ──
       Une carte ne surgit plus au bord de la bande : elle monte en opacite
       sur les cent cinquante derniers pixels avant d'entrer par la droite,
       et redescend de meme en sortant par la gauche. Rien qu'une
       soustraction par carte et par image — les abscisses sont deja
       connues. */
    function fondsDeBord() {
      if (!cartes.length) return;
      /* Telephone : rien — la piste se prend au doigt, et ecrire vingt
         opacites par frame pendant le geste la faisait saccader (Max,
         05/09 : « la frise est pas assez smooth »). */
      if (!mq.matches) return;
      var vg = friseBox.scrollLeft;
      var vd = vg + friseBox.clientWidth;
      for (var i = 0; i < cartes.length; i++) {
        var c = cartes[i];
        var v = 0;
        if (c.d > vg && c.g < vd) {
          v = Math.min((c.d - vg) / ZONE, (vd - c.g) / ZONE);
          if (v > 1) v = 1;
          if (v < 0) v = 0;
        }
        var t = v >= 0.995 ? '' : v.toFixed(3);
        if (c.o !== t) {
          c.el.style.opacity = t;
          c.o = t;
        }
      }
    }

    /* ── LES DEUX RANGEES A LA MEME LONGUEUR (Max, 03/09) ──
       Sur telephone la serie tient deux rangees l'une sur l'autre, et la
       boucle les replie ensemble, modulo UNE largeur. Deux rangees de
       longueurs differentes ne peuvent donc pas se raccorder toutes les
       deux : la plus courte finit avant, et le vide qui suit jusqu'a sa
       copie EST le trou. Le gabarit repartit deja les photos pour que les
       deux sommes de largeurs soient proches, mais « proche » ne suffit pas
       — il faut EGAL.

       On mesure, et on rattrape le reste en hauteur : a largeur automatique,
       une carte 4 % plus haute est 4 % plus large. Les ecarts, eux, ne
       suivent pas l'echelle, d'ou le calcul sur la seule part des images.
       On vise la moyenne des deux, pour que la correction se partage plutot
       que de tomber entiere sur une rangee. */
    var equilibrant = false;

    function equilibreRangees() {
      var lanes = friseTrack.querySelectorAll('[data-brt-serie] .brt-album__lane');
      if (lanes.length !== 2) return false;
      /* Sur ordinateur les rangees sont en `display: contents` : elles n'ont
         pas de boite, rien a egaliser, et tout est deja sur une ligne. */
      if (getComputedStyle(lanes[0]).display === 'contents') {
        var remis = false;
        Array.prototype.forEach.call(lanes, function (l) {
          if (l.style.getPropertyValue('--brt-lane-k')) {
            l.style.removeProperty('--brt-lane-k');
            remis = true;
          }
        });
        return remis;
      }
      /* ON ADDITIONNE LES CARTES, on ne lit pas la boite. `scrollWidth`
         renvoie ici la largeur du BLOC, et le bloc des deux rangees est
         celui de la plus large : les deux annoncaient la meme chose alors
         que l'une etait visiblement plus courte — c'est precisement le
         trou qu'on chasse. Seule la somme des cartes dit la verite. */
      var infos = [];
      for (var i = 0; i < lanes.length; i++) {
        var l = lanes[i];
        var cartesL = l.querySelectorAll('.brt-album__item');
        var n = cartesL.length;
        if (!n) return false;
        var ecart = parseFloat(getComputedStyle(l).columnGap) || 0;
        var images = 0;
        for (var c = 0; c < n; c++) images += cartesL[c].offsetWidth;
        if (!(images > 0)) return false;
        var k = parseFloat(l.style.getPropertyValue('--brt-lane-k')) || 1;
        infos.push({
          el: l,
          ecarts: ecart * (n - 1),
          images: images,
          total: images + ecart * (n - 1),
          k: k
        });
      }
      var cible = (infos[0].total + infos[1].total) / 2;
      var bouge = false;
      for (var j = 0; j < infos.length; j++) {
        var o = infos[j];
        var kk = ((cible - o.ecarts) * o.k) / o.images;
        if (!isFinite(kk) || kk <= 0) continue;
        /* Bornee, mais LARGE : le gabarit repartit deja les photos pour que
           les deux sommes soient proches, donc le coefficient reste pres de
           1 en pratique — cette borne n'est qu'un garde-fou pour une serie
           tres desequilibree (tous les paysages d'un cote). Assez large
           pour qu'elle ferme quand meme le raccord dans ce cas : un trou se
           voit plus qu'une rangee un peu plus haute que l'autre. Et sous un
           demi pour cent on ne touche a rien — sans ce seuil, mesure et
           correction se relanceraient l'une l'autre sans fin. */
        kk = Math.max(0.6, Math.min(1.7, kk));
        if (Math.abs(kk - o.k) > 0.005) {
          o.el.style.setProperty('--brt-lane-k', kk.toFixed(4));
          bouge = true;
        }
      }
      return bouge;
    }

    function mesurer() {
      /* La correction change la taille des cartes, donc reveille le
         ResizeObserver : sans ce verrou les deux se relanceraient en
         boucle. */
      if (equilibrant) return;
      equilibrant = true;
      var corrige = equilibreRangees();
      equilibrant = false;
      var direct = friseTrack.querySelectorAll('[data-brt-serie] .brt-album__item');
      var it = friseTrack.querySelectorAll('.brt-album__item');
      var n = direct.length;
      serie = (n >= 1 && it[n] && it[0]) ? it[n].offsetLeft - it[0].offsetLeft : 0;
      /* Sans quoi couvrir le raccord, pas de boucle : on laisse la piste
         bornee, la derive s'arretera au bout. */
      if (friseTrack.scrollWidth - serie < friseBox.clientWidth) serie = 0;
      mesurerCartes();
      /* Les boites viennent de bouger : on remesure une fois, sur la trame
         suivante, pour que le raccord se cale sur les nouvelles largeurs. */
      if (corrige) requestAnimationFrame(mesurer);
    }

    mesurer();
    window.addEventListener('load', mesurer);
    window.addEventListener('resize', mesurer, { passive: true });
    Array.prototype.forEach.call(friseTrack.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', mesurer, { once: true });
    });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(mesurer).observe(friseTrack);
    }

    var baseSpeed = 0.35;
    var spd = baseSpeed;
    var targetSpeed = baseSpeed;
    var pos = 0;
    var dragging = false;
    var paused = false;
    var nudgeTimer = null;
    var touchHold = false;
    var lastScroll = 0;

    /* La derive tourne PARTOUT desormais (Max, 02/09 nuit : « la frise
       doit tourner toute seule comme sur ordi ») — seul reduced-motion
       l'arrete. Le survol ne la stoppe plus non plus. */
    var gele = false;

    function actif() {
      return !mqReduce.matches && !gele;
    }

    function freeze(on) {
      gele = !!on;
      if (!gele) {
        /* On repart de la ou la piste s'est arretee, pas de la ou elle en
           etait avant le gel. */
        pos = friseBox.scrollLeft;
        paused = false;
        targetSpeed = baseSpeed;
      }
    }

    function step() {
      /* Le doigt a lache et l'inertie s'est posee : on repart de la ou la
         piste s'est arretee. */
      if (paused && !touchHold && !dragging && Date.now() - lastScroll > 350) {
        pos = friseBox.scrollLeft;
        paused = false;
        targetSpeed = baseSpeed;
      }
      if (actif() && !dragging && !paused) {
        spd += (targetSpeed - spd) * 0.06;
        pos += spd;
        if (serie > 0 && pos >= serie) pos -= serie;
        friseBox.scrollLeft = pos;
      }
      fondsDeBord();
      requestAnimationFrame(step);
    }
    step();

    /* Au doigt : le defilement natif prend la main, la derive attend. */
    friseBox.addEventListener('touchstart', function () {
      touchHold = true;
      paused = true;
      lastScroll = Date.now();
    }, { passive: true });
    friseBox.addEventListener('touchend', function () {
      touchHold = false;
      lastScroll = Date.now();
    }, { passive: true });
    friseBox.addEventListener('scroll', function () {
      if (paused) lastScroll = Date.now();
    }, { passive: true });

    /* ── A LA MAIN ── le meme drag que les avis : pointeur pose, la piste
       suit, et un vrai deplacement etouffe le clic qui suivrait — sinon
       chaque drag ouvrirait la visionneuse. */
    var startX = 0;
    var startScroll = 0;
    friseMoved = false;

    function resumeFromCurrent() {
      dragging = false;
      pos = friseBox.scrollLeft;
      targetSpeed = baseSpeed;
      paused = false;
    }

    friseBox.addEventListener('pointerdown', function (e) {
      if (!actif()) return;
      /* Souris seulement : au doigt, c'est le defilement natif qui drague. */
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      friseMoved = false;
      startX = e.clientX;
      startScroll = friseBox.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) friseMoved = true;
      friseBox.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      resumeFromCurrent();
    });
    window.addEventListener('pointercancel', function () {
      if (!dragging) return;
      resumeFromCurrent();
    });
    window.addEventListener('blur', function () {
      if (!dragging) return;
      resumeFromCurrent();
    });
    Array.prototype.forEach.call(friseTrack.querySelectorAll('img'), function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && !dragging) resumeFromCurrent();
    });

    /* ── LES FLECHES ── un pas de vignette, en douceur, puis la derive
       reprend — apres repli si on a depasse la serie. */
    function glide(dir) {
      if (!actif()) return;
      paused = true;
      /* Sans ca, au PREMIER clic, `lastScroll` valait encore zero : step()
         voyait une pause vieille de plus de 350 ms, la levait a la frame
         suivante et reposait `scrollLeft = pos` — le glissement etait
         ecrase avant d'avoir bouge (Max, 05/09 : « marchent pas du premier
         coup »). */
      lastScroll = Date.now();
      friseBox.scrollBy({ left: (dir > 0 ? 1 : -1) * pas(), behavior: glisse() });
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(function () {
        pos = friseBox.scrollLeft;
        if (serie > 0 && pos >= serie) {
          pos -= serie;
          friseBox.scrollLeft = pos;
        }
        paused = false;
      }, 550);
    }

    /* LES FLECHES DE LA BANDE (Max, 05/09) : sous la frise, a droite. Meme
       pas, meme amorti que le dock d'avant — c'est glide() qui fait tout. */
    Array.prototype.forEach.call(friseEl.querySelectorAll('[data-brt-frise-prev]'), function (b) {
      b.addEventListener('click', function () { glide(-1); });
    });
    Array.prototype.forEach.call(friseEl.querySelectorAll('[data-brt-frise-next]'), function (b) {
      b.addEventListener('click', function () { glide(1); });
    });

    return {
      el: friseEl,
      box: friseBox,
      track: friseTrack,
      /* Les fleches sous la bande : elles suivent son fondu (Max, 05/09 :
         « apparaitre et disparaitre en meme temps que la frise »). */
      nav: friseEl.querySelector('.brt-frise__nav'),
      glide: glide,
      freeze: freeze,
      moved: function () { return friseMoved; },
      pas: pas
    };
  }

  $$('[data-brt-frise]').forEach(function (el) {
    var box = el.querySelector('[data-brt-album]');
    var track = el.querySelector('[data-brt-album-track]');
    if (!box || !track) return;
    var api = monteFrise(el, box, track);
    if (api) frises.push(api);
  });

  if (frises.length) {
    friseEl = frises[0].el;
    friseBox = frises[0].box;
    friseTrack = frises[0].track;
    /* Le gel vaut pour TOUTES : on ouvre une photo, plus rien ne roule. */
    friseFreeze = function (on) {
      frises.forEach(function (f) { f.freeze(on); });
    };
  }

  /* ══════════════════ 8 bis a. LA VISIONNEUSE DE LA FRISE ══════════════════
     Refaite le 02/09 (« quand je clique sur une image il faut qu'elle
     s'agrandisse dans le bloc de gauche, la ca fait de la merde, et quand
     je clique ailleurs on quitte mal »). Trois corrections :

       1. LA SCENE EST CALEE SUR LE BLOC DE GAUCHE, au pixel. On mesure
          .product__media-wrapper et on pose quatre variables ; la feuille
          ne fait plus la moitie de l'ecran au juge. Sur telephone, plein
          ecran.
       2. CLIQUER N'IMPORTE OU FERME. La boite couvre tout l'ecran et
          n'attrape que les clics : la colonne de droite en fait partie.
       3. LA PHOTO S'AGRANDIT — elle arrive a 92 % et se pose, au lieu
          d'apparaitre d'un bloc.

     Les sources sont les cartes de la PREMIERE serie — la copie de boucle
     montrerait chaque photo deux fois. */
  (function lightbox() {
    var lb = $('[data-brt-lb]');
    if (!lb || !frises.length) return;
    /* La bande d'ou vient la photo ouverte : il y en a plusieurs, et les
       fleches doivent feuilleter CELLE-LA, pas la premiere venue. */
    var srcTrack = frises[0].track;
    var imgEl = lb.querySelector('[data-brt-lb-img]');
    var stage = lb.querySelector('[data-brt-lb-stage]');
    var countEl = lb.querySelector('[data-brt-lb-count]');
    var wrapEl = $('.product__media-wrapper');
    var idx = 0;
    var rendre = null;
    var offTimer = null;
    var glisseTimer = null;
    var swipeAt = 0;

    /* ── LE SCROLL EST COUPE PENDANT LA VISIONNEUSE (Max, 02/09) ──
       On ne touche NI a l'`overflow` du body NI a sa position : la colonne
       de droite est collante, et un `overflow: hidden` pose la-dessus la
       decroche. On intercepte les gestes, c'est tout. Le pincement passe —
       deux doigts sur une photo, c'est un zoom, pas un defilement. */
    var TOUCHES_SCROLL = {
      ' ': 1, 'Spacebar': 1, 'PageUp': 1, 'PageDown': 1,
      'Home': 1, 'End': 1, 'ArrowUp': 1, 'ArrowDown': 1
    };

    function bloqueGeste(e) {
      if (e.touches && e.touches.length > 1) return;
      e.preventDefault();
    }

    function bloqueTouche(e) {
      if (TOUCHES_SCROLL[e.key]) e.preventDefault();
    }

    function verrouScroll(on) {
      var m = on ? 'addEventListener' : 'removeEventListener';
      document[m]('wheel', bloqueGeste, { passive: false });
      document[m]('touchmove', bloqueGeste, { passive: false });
      document[m]('keydown', bloqueTouche, false);
    }

    function items() {
      return Array.prototype.slice.call(
        srcTrack.querySelectorAll('[data-brt-serie] .brt-album__item')
      );
    }

    function srcOf(fig) {
      var full = fig.getAttribute('data-brt-full');
      if (full) return full;
      var im = fig.querySelector('img');
      return im ? (im.currentSrc || im.src) : '';
    }

    /* LA SCENE PREND LA PLACE DU BLOC DE GAUCHE — sa largeur, son bord, et
       ce qui reste de hauteur sous l'en-tete. Recalculee a chaque scroll :
       la colonne bouge avec la page. */
    function place() {
      var large = false;
      try { large = window.matchMedia('(min-width: 900px)').matches; } catch (e) {}
      if (!large || !wrapEl) {
        lb.style.setProperty('--brt-lb-x', '0px');
        lb.style.setProperty('--brt-lb-y', '0px');
        lb.style.setProperty('--brt-lb-w', '100%');
        lb.style.setProperty('--brt-lb-h', '100%');
        return;
      }
      var r = wrapEl.getBoundingClientRect();
      var haut = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--brt-top')
      ) || 85;
      lb.style.setProperty('--brt-lb-x', Math.round(r.left) + 'px');
      lb.style.setProperty('--brt-lb-y', Math.round(haut) + 'px');
      lb.style.setProperty('--brt-lb-w', Math.round(r.width) + 'px');
      lb.style.setProperty('--brt-lb-h', Math.round(window.innerHeight - haut) + 'px');
    }

    /* ── LES VOISINES SONT DEJA LA (Max, 03/09 : « affreusement long ») ──
       Une photo de la visionneuse fait 1800 px de large. La demander au
       reseau au moment ou le doigt la reclame, c'est attendre le reseau a
       chaque photo — d'ou la lenteur. On la demande UNE PHOTO PLUS TOT : le
       navigateur la garde en cache, et le passage devient instantane. Le
       cache des objets Image evite aussi de relancer une requete deja
       partie. */
    var precharges = {};

    function precharger(list, i) {
      if (!list.length) return;
      [i - 1, i + 1].forEach(function (j) {
        var k = ((j % list.length) + list.length) % list.length;
        var s = srcOf(list[k]);
        if (!s || precharges[s]) return;
        precharges[s] = new Image();
        precharges[s].src = s;
      });
    }

    function nu() {
      imgEl.style.transition = '';
      imgEl.style.transform = '';
      imgEl.style.opacity = '';
    }

    /** `sens` : +1 on va vers la suivante, -1 vers la precedente, rien du
     *  tout a l'ouverture. Avec un sens, la photo SORT du cote du geste et
     *  la suivante ENTRE de l'autre — c'est ce mouvement qui manquait
     *  (Max, 03/09 : « le tactile a pas d'animation propre »). Sans sens,
     *  on garde le fondu d'ouverture, qui lui attend le chargement puisque
     *  rien n'a pu etre precharge. */
    function show(i, sens) {
      var list = items();
      if (!list.length) return;
      idx = ((i % list.length) + list.length) % list.length;
      var src = srcOf(list[idx]);
      if (!src) return;
      var im = list[idx].querySelector('img');
      var alt = im ? (im.alt || '') : '';
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + list.length;
      precharger(list, idx);

      /* En mouvement reduit, la photo suivante ne glisse pas : le fondu. */
      if (!sens || glisse() === 'auto') {
        /* Le fondu attend le chargement : la grande image arrive du reseau,
           et sans cette attente elle POPPAIT (Max, 02/09 nuit). */
        nu();
        imgEl.classList.remove('is-in');
        imgEl.onload = function () { imgEl.classList.add('is-in'); };
        imgEl.src = src;
        imgEl.alt = alt;
        if (imgEl.complete && imgEl.naturalWidth) {
          requestAnimationFrame(function () { imgEl.classList.add('is-in'); });
        }
        return;
      }

      var W = (stage ? stage.clientWidth : 0) || window.innerWidth || 400;
      var course = W * 0.55;
      imgEl.onload = null;
      imgEl.style.transition = 'transform 0.15s ease-in, opacity 0.15s ease-in';
      imgEl.style.transform = 'translateX(' + (-sens * course).toFixed(0) + 'px)';
      imgEl.style.opacity = '0';
      clearTimeout(glisseTimer);
      glisseTimer = setTimeout(function () {
        imgEl.src = src;
        imgEl.alt = alt;
        /* Posee de l'autre cote SANS transition, sinon elle traverserait
           l'ecran au lieu d'y entrer. */
        imgEl.style.transition = 'none';
        imgEl.style.transform = 'translateX(' + (sens * course).toFixed(0) + 'px)';
        requestAnimationFrame(function () {
          imgEl.style.transition = 'transform 0.25s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.2s ease-out';
          imgEl.style.transform = 'translateX(0px)';
          imgEl.style.opacity = '1';
        });
      }, 150);
    }

    function open(i) {
      rendre = document.activeElement;
      clearTimeout(offTimer);
      clearTimeout(glisseTimer);
      /* Un glisse interrompu a pu laisser un transform en ligne : l'ouverture
         doit repartir d'une image nue, sinon elle entre de travers. */
      nu();
      if (friseFreeze) friseFreeze(true);
      verrouScroll(true);
      place();
      lb.hidden = false;
      /* Une trame : la scene doit avoir ete peinte a opacite nulle avant
         qu'on l'allume, sinon il n'y a pas de fondu, juste un saut. */
      requestAnimationFrame(function () { lb.classList.add('is-on'); });
      show(i);
      var c = lb.querySelector('[data-brt-lb-close]');
      if (c && c.focus) c.focus();
      window.addEventListener('scroll', place, { passive: true });
      window.addEventListener('resize', place);
    }

    function close() {
      clearTimeout(glisseTimer);
      /* Les styles en ligne du glisse gagnent sur `.is-in` : sans ce
         nettoyage, la fermeture n'aurait aucun fondu. */
      nu();
      lb.classList.remove('is-on');
      imgEl.classList.remove('is-in');
      if (friseFreeze) friseFreeze(false);
      verrouScroll(false);
      window.removeEventListener('scroll', place);
      window.removeEventListener('resize', place);
      clearTimeout(offTimer);
      offTimer = setTimeout(function () {
        lb.hidden = true;
        imgEl.removeAttribute('src');
      }, 280);
      if (rendre && rendre.focus) rendre.focus();
    }

    frises.forEach(function (f) {
      f.track.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        /* Un drag qui vient de se finir n'est pas un clic. */
        if (f.moved()) return;
        var fig = e.target.closest('.brt-album__item');
        if (!fig) return;
        srcTrack = f.track;
        var list = items();
        var i = list.indexOf(fig);
        /* Une carte de la copie renvoie a son original. */
        if (i === -1) {
          var all = Array.prototype.slice.call(f.track.querySelectorAll('.brt-album__item'));
          i = all.indexOf(fig) % (list.length || 1);
        }
        if (i >= 0) open(i);
      });
    });

    lb.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      /* Le clic fantome qui suit un balayage ne compte pas. */
      if (Date.now() - swipeAt < 400) return;
      if (e.target.closest('[data-brt-lb-prev]')) { show(idx - 1, -1); return; }
      if (e.target.closest('[data-brt-lb-next]')) { show(idx + 1, 1); return; }
      if (e.target.closest('[data-brt-lb-close]')) { close(); return; }
      /* Toucher la photo avance ; TOUT le reste ferme — la scene, ses
         marges, et l'ecran autour, colonne de droite comprise. */
      if (e.target === imgEl) { show(idx + 1, 1); return; }
      close();
    });

    /* ── LE BALAYAGE, SUR TELEPHONE ──
       La boite porte `touch-action: pinch-zoom` : le geste horizontal ne
       fait plus defiler la page derriere, il passe d'une photo a l'autre —
       et le pincement reste au navigateur, on doit pouvoir zoomer. */
    if (stage) {
      var tx = 0;
      var ty = 0;
      var suit = false;
      var dxCourant = 0;

      stage.addEventListener('touchstart', function (e) {
        /* A deux doigts on pince pour zoomer : ce n'est pas notre geste. */
        if (!e.touches || e.touches.length !== 1) return;
        tx = e.touches[0].clientX;
        ty = e.touches[0].clientY;
        suit = false;
        dxCourant = 0;
      }, { passive: true });

      /* LA PHOTO SUIT LE DOIGT (Max, 03/09). Avant, rien ne bougeait pendant
         le geste : on balayait dans le vide, puis l'image changeait une fois
         le doigt leve. On ne prend la main qu'apres huit pixels franchement
         horizontaux — en dessous, ca peut encore etre un defilement ou un
         pincement, et on ne veut pas le voler. */
      stage.addEventListener('touchmove', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - tx;
        var dy = e.touches[0].clientY - ty;
        if (!suit) {
          if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
          suit = true;
          clearTimeout(glisseTimer);
          imgEl.style.transition = 'none';
        }
        dxCourant = dx;
        imgEl.style.transform = 'translateX(' + (dx * 0.85).toFixed(0) + 'px)';
        imgEl.style.opacity = Math.max(0.4, 1 - Math.abs(dx) / 560).toFixed(3);
      }, { passive: true });

      stage.addEventListener('touchend', function () {
        if (!suit) return;
        suit = false;
        var dx = dxCourant;
        if (Math.abs(dx) > 44) {
          swipeAt = Date.now();
          var sens = dx < 0 ? 1 : -1;
          show(idx + sens, sens);
        } else {
          /* Pas assez loin : elle revient a sa place plutot que de changer. */
          imgEl.style.transition = 'transform 0.25s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.25s ease';
          imgEl.style.transform = 'translateX(0px)';
          imgEl.style.opacity = '1';
        }
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1, -1);
      else if (e.key === 'ArrowRight') show(idx + 1, 1);
    });
  })();

  /* ══════════════════ 8 bis. LE DOCK DE FLECHES ══════════════════
     Un seul couple de fleches, colle en bas a droite, qui suit le visiteur
     et change de role selon la scene (Max, 02/09) : scene 1 il feuillette
     les vues, scene 2 il fait defiler la frise, scene 3 il se retourne —
     une haut, une bas — et passe d'une histoire a l'autre. */
  (function dock() {
    var dockEl = $('[data-brt-dock]');
    if (!dockEl) return;
    var dPrev = $('[data-brt-dock-prev]');
    var dNext = $('[data-brt-dock-next]');
    var topFix = $('[data-brt-topfix]');
    var albumScene = $('.brt-scene--album');
    var storyEl = $('.brt-b');
    var chapters = storyEl ? Array.prototype.slice.call(storyEl.querySelectorAll('.brt-b__chapter')) : [];
    /* La frise active au dernier calcul de zone() — null hors zone 3. */
    var zoneFrise = null;
    /* Vrai/faux quand le dock est en mode horizontal ou vertical, null tant
       que refresh() n'a pas tourne une premiere fois : sert a detecter le
       changement de role pour le fondu, dans refresh(), sans faire
       clignoter le dock des l'arrivee sur la page. */
    var enFrise = null;

    /* Quatre zones desormais : 1 le packshot, 2 la paire et le debut du
       recit, 3 une frise epinglee, 4 les chapitres. Des la zone 2 tout est
       vertical — les fleches se retournent et poussent le scroll.

       DEUX FRISES, DEUX FOIS LA MEME BASCULE (Max, 04/09 : « y'a deux
       frises donc ca arrive deux fois »). Le zonage ne designe plus LA
       frise (la premiere) : on compare le haut de chaque repere — la
       paire, CHAQUE frise, chaque chapitre — a la mi-hauteur, et c'est le
       repere le plus avance (le top le plus grand sous la ligne) qui
       gagne. Zone 3 retient en plus LAQUELLE, dans `zoneFrise`, pour que
       les fleches fassent avancer la bonne piste. */
    function zone() {
      var mid = window.innerHeight * 0.5;
      var gagnant = 1;
      var top = -Infinity;
      zoneFrise = null;
      if (albumScene) {
        var ta = albumScene.getBoundingClientRect().top;
        if (ta < mid && ta > top) { top = ta; gagnant = 2; }
      }
      frises.forEach(function (f) {
        var tf = f.el.getBoundingClientRect().top;
        if (tf < mid && tf > top) { top = tf; gagnant = 3; zoneFrise = f; }
      });
      if (chapters.length) {
        chapters.forEach(function (c) {
          var tc = c.getBoundingClientRect().top;
          if (tc < mid && tc > top) { top = tc; gagnant = 4; }
        });
      } else if (storyEl) {
        var ts = storyEl.getBoundingClientRect().top;
        if (ts < mid && ts > top) { top = ts; gagnant = 4; }
      }
      /* Un chapitre peut gagner APRES qu'une frise a pose `zoneFrise` dans
         la boucle du dessus — sans ce garde-fou elle resterait posee alors
         qu'on n'est plus en zone 3. */
      if (gagnant !== 3) zoneFrise = null;
      return gagnant;
    }

    function pasAlbum() {
      var track = zoneFrise ? zoneFrise.track : friseTrack;
      var box = zoneFrise ? zoneFrise.box : friseBox;
      if (!track) return 300;
      var it = track.querySelectorAll('.brt-album__item');
      if (it.length > 1) return it[1].offsetLeft - it[0].offsetLeft;
      return Math.round((box ? box.clientWidth : 600) * 0.6);
    }

    /* Le chapitre « en cours » : le dernier dont le haut est passe au-dessus
       de la mi-hauteur d'ecran. */
    function chapterAt() {
      var mid = window.innerHeight * 0.5;
      var idx = -1;
      chapters.forEach(function (c, i) {
        if (c.getBoundingClientRect().top < mid) idx = i;
      });
      return idx;
    }

    function go(dir) {
      var z = zone();
      if (z === 1) {
        showShot(shotIndex + dir);
      } else if (z === 2) {
        if (dir < 0) {
          window.scrollTo({ top: 0, behavior: glisse() });
        } else if (friseEl) {
          friseEl.scrollIntoView({ behavior: glisse(), block: 'start' });
        } else if (chapters[0]) {
          chapters[0].scrollIntoView({ behavior: glisse(), block: 'center' });
        }
      } else if (z === 3) {
        /* La frise avance d'une vignette, en douceur — les fleches parlent
           directement a la piste, plus au scroll de la page. `zone()` vient
           de tourner et a pose `zoneFrise` : celle sous la ligne, pas
           forcement la premiere. */
        if (zoneFrise) zoneFrise.glide(dir * pasAlbum());
      } else {
        var idx = chapterAt();
        var cible = idx + dir;
        if (cible < 0) {
          if (friseEl) friseEl.scrollIntoView({ behavior: glisse(), block: 'end' });
          else if (albumScene) albumScene.scrollIntoView({ behavior: glisse(), block: 'start' });
          return;
        }
        if (cible > chapters.length - 1) return;
        chapters[cible].scrollIntoView({ behavior: glisse(), block: 'center' });
      }
    }

    /* LE DOCK S'EFFACE EN ZONE FRISE (Max, 05/09 : « des fleches gauche/
       droite accrochees sous la frise... leur presence provoque la
       disparition des fleches haut/bas »). L'ancrage en `position: fixed`
       du 04/09 est parti : la bande porte ses propres fleches, dans le flux
       (snippets/bisou-tshirt-frise.liquid), et deux paires a l'ecran se
       disputeraient le geste. `.is-off` fond le dock ; il revient, vertical,
       des qu'on passe aux chapitres. */
    function refresh() {
      var z = zone();
      dockEl.classList.toggle('is-off', z === 3);
      /* Les fleches ne se couchent (horizontales) qu'en zone 1 : en zone
         frise le dock est cache, ailleurs elles poussent la page. */
      var horizontal = z === 1;
      /* LA BASCULE SE VOIT (Max, 04/09 : « quand la frise arrive les fleches
         se tournent... et quand la frise monte les fleches disparaissent,
         transition opacite simple »). A chaque changement de role — la
         frise arrive (vertical -> horizontal) ou s'en va (l'inverse), dans
         les deux sens de scroll — le dock s'efface un instant puis
         revient, pendant que le SVG tourne sous le fondu. */
      if (enFrise !== null && horizontal !== enFrise) {
        dockEl.classList.add('is-swap');
        setTimeout(function () { dockEl.classList.remove('is-swap'); }, 260);
      }
      enFrise = horizontal;
      dockEl.classList.toggle('is-story', z === 2 || z === 4);
      /* Le retour au produit s'allume des qu'on a quitte la scene 1. */
      if (topFix) topFix.classList.toggle('is-on', z >= 2);
      if (z === 1) {
        var vis = visibleShots();
        if (dPrev) dPrev.disabled = shotIndex <= 0;
        if (dNext) dNext.disabled = shotIndex >= vis.length - 1;
      } else if (z === 4) {
        var idx = chapterAt();
        if (dPrev) dPrev.disabled = false;
        if (dNext) dNext.disabled = idx >= chapters.length - 1;
      } else {
        if (dPrev) dPrev.disabled = false;
        if (dNext) dNext.disabled = false;
      }
    }

    if (dPrev) dPrev.addEventListener('click', function () { go(-1); });
    if (dNext) dNext.addEventListener('click', function () { go(1); });

    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        refresh();
      });
    }, { passive: true });

    dockRefresh = refresh;
    refresh();
  })();

  /* ══════════════════ 8 bis b. LES BILLES DE PROGRESSION ══════════════════
     Cinq billes a mi-hauteur, une par etape — produit, manifeste, video,
     frise, infos. La bille de l'etape en cours s'allume, un clic y va
     (Max, 02/09 nuit). Le dessin est celui de .brt-scene-nav, deja en
     place. */
  (function sceneNav() {
    var nav = $('[data-brt-nav]');
    if (!nav) return;
    var dots = Array.prototype.slice.call(nav.querySelectorAll('.brt-scene-dot'));
    var targets = [
      $('.brt-scene--shot'),
      $('.brt-scene--album'),
      $('.brt-feature'),
      friseEl,
      $('.brt-b')
    ];

    dots.forEach(function (d, i) {
      d.hidden = !targets[i];
      d.addEventListener('click', function () {
        if (i === 0) {
          window.scrollTo({ top: 0, behavior: glisse() });
          return;
        }
        if (targets[i]) targets[i].scrollIntoView({ behavior: glisse(), block: 'start' });
      });
    });

    var raf = false;
    function refresh() {
      var mid = window.innerHeight * 0.5;
      var idx = 0;
      for (var i = 1; i < targets.length; i++) {
        if (targets[i] && targets[i].getBoundingClientRect().top < mid) idx = i;
      }
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }

    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        raf = false;
        refresh();
      });
    }, { passive: true });
    refresh();
  })();

  /* ══════════════════ 8 ter bis. LES VIDEOS DU RECIT ══════════════════
     L'attribut autoplay ne suffit pas partout : iOS exige playsinline, et
     un navigateur peut refuser la lecture d'une video arrivee hors ecran
     (« sur ordi je vois pas la video », Max, 02/09 nuit). On force donc les
     deux attributs et on relance play() quand la video entre a l'ecran —
     et on la met en pause quand elle en sort, elle n'a rien a jouer. */
  (function chapterVideos() {
    var vids = $$('.brt-b__media video');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
    });
    if (typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* refus : l'affiche reste */ });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ══════════════════ 8 quater. LE SCRUB ══════════════════
     Tout le recit est PILOTE par la position de scroll, image par image,
     dans les deux sens (Max, 02/09 : « au centre les choses qu'on veut voir,
     trop haut ou trop bas ca disparait — qu'on sente qu'il se passe des
     choses »). Un seul rAF, un seul endroit qui ecrit des transforms.

       · LE MORPHING EST EXACT : le packshot descend et retrecit jusqu'a se
         poser PIXEL POUR PIXEL sur la premiere vignette de la paire — les
         deux boites sont mesurees a chaque image, transform neutralise le
         temps de la mesure. La vignette cible ne recoit JAMAIS de
         transform, sinon la mesure ment. La seconde vue arrive en fondu
         par la droite.
       · LE TEXTE S'ECRIT : le premier chapitre, sous la paire, est decoupe
         en mots ; chacun apparait a son tour, de gauche a droite, au rythme
         du scroll — et s'efface a l'envers en remontant.
       · LA FRISE VOYAGE : epinglee, elle avance d'autant que le rail est
         parcouru — le scroll vertical devient un travelling horizontal.
       · LES CHAPITRES ENTRENT PAR LES COTES : le media d'un bord, le texte
         de l'autre, selon leur distance au centre de l'ecran — pleins au
         centre, effaces un peu AVANT les bords (Max : « au-dessus et en
         dessous ca disparait meme un peu avant »).
       · LA SOURIS FAIT FLOTTER LE PACKSHOT : quelques pixels vers elle,
         amortis par la transition de .brt-stage — jamais pendant le
         morphing ni sous un panneau noir, dont la classe pose son propre
         transform sur la meme boite.

     Telephone : le morphing, la frise et la parallaxe n'existent pas, mais
     l'ecriture des mots et les entrees laterales restent — « l'histoire
     commence en dessous de la meme maniere » (Max, 02/09 soir).
     prefers-reduced-motion : aucun style pose, tout est simplement la. */
  (function scrub() {
    var mqd = null;
    var mqr = null;
    var mqh = null;
    try {
      mqd = window.matchMedia('(min-width: 900px)');
      mqr = window.matchMedia('(prefers-reduced-motion: reduce)');
      mqh = window.matchMedia('(hover: hover)');
    } catch (e) { return; }

    var stageEl = $('.brt-stage');
    var shotsEl = $('.brt-shots');
    var albumScene = $('.brt-scene--album');
    var pairEl = $('[data-brt-pair]');
    var introEl = $('[data-brt-intro]');
    var storyBits = $$('.brt-b__chapter');
    var footEl = $('.brt-b__foot');
    var startEl = $('.brt-b__start');
    var railEl = $('[data-brt-rail]');
    var startDot = $('.brt-b__start-dot');
    var shotsNavEl = $('.brt-shots-nav');
    var wrap = $('.product__media-wrapper');

    function clampN(n, a, b) { return Math.max(a, Math.min(b, n)); }

    function clear(el) {
      if (!el) return;
      el.style.opacity = '';
      el.style.transform = '';
    }

    /* ── LES TEXTES DECOUPES EN MOTS ──
       Une seule fois au chargement : chaque mot devient un <span
       class="brt-w">, les espaces restent des noeuds de texte. Sans inline
       style pose, un mot est simplement visible — le repli ne cache rien.
       Le premier chapitre s'ECRIT (fondu seul, gauche → droite) ; ceux du
       recit MONTENT mot a mot — le geste du volet de la precommande, mais
       pilote par le scroll, donc reversible. */
    /** Deux niveaux de decoupe. Le MOT toujours — c'est lui qui garde la
     *  ligne coupable entre les mots et jamais au milieu d'un. La LETTRE en
     *  plus pour le manifeste (Max, 02/09 : « le texte doit apparaitre
     *  presque lettre par lettre »), et c'est alors la lettre qui entre dans
     *  la reserve : la vague glisse sur les caracteres. */
    function decoupe(node, sink, parLettre) {
      var enfants = Array.prototype.slice.call(node.childNodes);
      enfants.forEach(function (child) {
        if (child.nodeType === 1) { decoupe(child, sink, parLettre); return; }
        if (child.nodeType !== 3 || !child.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        /* Les espaces insecables (« Siga Siga », 24/10) restent DANS le mot :
           coupes ici, ils separaient deux .brt-w (inline-block) et « » »
           tombait seul en debut de ligne au telephone. */
        child.nodeValue.split(/([^\S\u00A0\u202F]+)/).forEach(function (part) {
          if (!part) return;
          if (/^[^\S\u00A0\u202F]+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
            return;
          }
          var span = document.createElement('span');
          span.className = 'brt-w';
          if (parLettre) {
            for (var i = 0; i < part.length; i++) {
              var lettre = document.createElement('span');
              lettre.className = 'brt-l';
              lettre.textContent = part.charAt(i);
              span.appendChild(lettre);
              sink.push(lettre);
            }
          } else {
            span.textContent = part;
            sink.push(span);
          }
          frag.appendChild(span);
        });
        node.replaceChild(frag, child);
      });
    }

    /* CHOREGRAPHIE DU MANIFESTE (Max, 03/09) : quatre elements, deux gestes.
       Le surtitre et le titre se levent d'un bloc — flou + opacite + une
       translation horizontale qui donne le sens (voir vagueBloc plus bas).
       Le sous-titre et le paragraphe s'ecrivent toujours lettre a lettre. */
    var chipEl = introEl && introEl.querySelector('.brt-intro__chip');
    var titleEl = introEl && introEl.querySelector('.brt-intro__title');
    var defL = [];
    var leadL = [];
    if (introEl) {
      var defEl = introEl.querySelector('.brt-intro__def');
      var leadEl = introEl.querySelector('.brt-intro__lead');
      if (defEl) decoupe(defEl, defL, true);
      if (leadEl) decoupe(leadEl, leadL, true);
    }
    var words = defL.concat(leadL);
    storyBits.forEach(function (ch) {
      var t = ch.querySelector('.brt-b__text');
      if (!t) return;
      var sink = [];
      decoupe(t, sink);
      ch.__brtWords = sink;
    });

    function clearWords() {
      words.forEach(function (w) {
        w.style.opacity = '';
        w.style.transform = '';
        w.style.filter = '';
        w.__k = undefined;
      });
      [chipEl, titleEl].forEach(function (el) {
        if (!el) return;
        el.style.opacity = '';
        el.style.transform = '';
        el.style.filter = '';
        el.__k = undefined;
      });
    }

    /* Le SURTITRE et le TITRE se levent d'un bloc — flou + opacite + une
       translation horizontale qui donne le sens du geste. `sens` vaut +1
       pour venir de la droite (le surtitre, Max : « de la droite vers la
       gauche »), -1 pour venir de la gauche (le titre, plus bas, un peu
       apres). Applique sur l'ELEMENT ENTIER — pas sur un span interne — pour
       que les deux tirets du surtitre, poses en ::before/::after, se
       revelent avec lui plutot que de rester fixes. */
    function vagueBloc(el, prog, sens) {
      if (!el) return;
      var o = clampN(prog, 0, 1);
      var k = o >= 0.999 ? -1 : Math.round(o * 24);
      if (el.__k === k) return;
      el.__k = k;
      if (k < 0) {
        el.style.opacity = '';
        el.style.transform = '';
        el.style.filter = '';
      } else {
        var dx = ((1 - o) * 28 * sens).toFixed(1);
        el.style.opacity = String(o.toFixed(3));
        el.style.transform = 'translateX(' + dx + 'px)';
        el.style.filter = 'blur(' + ((1 - o) * 6).toFixed(2) + 'px)';
      }
    }

    /* Le SOUS-TITRE et le PARAGRAPHE s'ecrivent lettre a lettre : une vague
       de 22 lettres glisse sur le tableau ; on n'ecrit que ce qui change. */
    function vagueLettres(arr, prog) {
      var Wd = 22;
      var M = arr.length;
      var pr = clampN(prog, 0, 1);
      for (var i = 0; i < M; i++) {
        var o = clampN((pr * (M + Wd) - i) / Wd, 0, 1);
        var k = o >= 0.999 ? -1 : Math.round(o * 20);
        var w = arr[i];
        if (w.__k === k) continue;
        w.__k = k;
        if (k < 0) {
          w.style.opacity = '';
          w.style.transform = '';
          w.style.filter = '';
        } else {
          w.style.opacity = String(o.toFixed(3));
          w.style.transform = 'translateY(' + ((1 - o) * 12).toFixed(1) + 'px)';
          w.style.filter = 'blur(' + ((1 - o) * 5).toFixed(2) + 'px)';
        }
      }
    }

    function clearChapter(ch) {
      clear(ch);
      var m = ch.querySelector('.brt-b__media');
      var t = ch.querySelector('.brt-b__text');
      clear(m);
      clear(t);
      (ch.__brtWords || []).forEach(function (w) {
        w.style.opacity = '';
        w.style.transform = '';
      });
    }

    function clearAll() {
      clear(shotsNavEl);
      if (shotsNavEl) shotsNavEl.style.pointerEvents = '';
      clear(shotsEl);
      if (shotsEl) {
        shotsEl.style.transition = '';
        shotsEl.style.pointerEvents = '';
      }
      clear(stageEl);
      if (pairEl) Array.prototype.forEach.call(pairEl.children, clear);
      frises.forEach(function (f) {
        f.track.style.transform = '';
        f.box.style.opacity = '';
        if (f.nav) f.nav.style.opacity = '';
      });
      if (railEl) railEl.style.removeProperty('--brt-rail');
      clearWords();
      storyBits.forEach(clearChapter);
      clear(footEl);
      clear(startEl);
      morphQ = 0;
    }

    /* Plein au centre, efface un peu AVANT les bords : la fenetre utile fait
       ±38 % de la demi-hauteur, puis on fond sur 42 %. */
    function vueAuCentre(el) {
      var vh = window.innerHeight;
      var r = el.getBoundingClientRect();
      var norm = (r.top + r.height / 2 - vh * 0.5) / (vh * 0.5);
      return clampN(1 - Math.max(0, Math.abs(norm) - 0.38) / 0.42, 0, 1);
    }

    /* Le media entre par son bord ; le texte, lui, MONTE mot a mot — le
       geste du volet de la precommande, reversible parce que pilote par la
       distance au centre. */
    function chapterFocus(ch) {
      var v = vueAuCentre(ch);
      if (v >= 0.999) {
        clearChapter(ch);
        return;
      }
      var desktop = mqd.matches;
      var m = ch.querySelector('.brt-b__media');
      var d = ((1 - v) * 46).toFixed(1);
      var fromRight = ch.classList.contains('brt-b__chapter--media-right');
      /* Sur telephone, le chapitre ne se voile pas et le media reste
         simplement la (Max, 02/09 nuit : « la video, la fait pas
         apparaitre, laisse-la normale ») — seuls les mots montent. */
      if (desktop) {
        /* PLANCHER A 0,45, plus a 0,25 (Max, 02/09 : « sur ordi y'a un moment
           ou c'est tout blanc »). Un chapitre qui sort du centre s'estompe,
           il ne s'efface pas : il reste toujours quelque chose a lire a
           l'ecran. */
        ch.style.opacity = String(Math.min(1, 0.45 + v * 0.55).toFixed(3));
      } else {
        ch.style.opacity = '';
      }
      ch.style.transform = '';
      if (m) {
        if (desktop) {
          m.style.transform = 'translateX(' + (fromRight ? d : -d) + 'px)';
          /* Le media tient bien plus longtemps que le texte : x2,2 — la
             video reste presente tant qu'elle est un tant soit peu a
             l'ecran (Max, 02/09 nuit, deux rappels). */
          m.style.opacity = String(Math.min(1, v * 2.2).toFixed(3));
        } else {
          clear(m);
        }
      }
      var ws = ch.__brtWords;
      if (ws && ws.length) {
        /* Le texte part APRES le media : il attend que la video soit posee
           au centre pour monter, mot a mot — le geste du volet de la
           precommande. */
        var vt = clampN((v - 0.3) / 0.7, 0, 1);
        var NW = ws.length;
        var WC = 5;
        for (var i = 0; i < NW; i++) {
          var o = clampN((vt * (NW + WC) - i) / WC, 0, 1);
          if (o >= 0.999) {
            ws[i].style.opacity = '';
            ws[i].style.transform = '';
          } else {
            ws[i].style.opacity = String(o.toFixed(3));
            ws[i].style.transform = 'translateY(' + ((1 - o) * 12).toFixed(1) + 'px)';
          }
        }
      }
    }

    /* La cible de la parallaxe, en [-1, 1] depuis le centre du bloc gauche.
       La transition de .brt-stage (0.85 s, sortie douce) fait l'amorti :
       pas de lissage a la main, la souris tire, la boite suit. */
    var parX = 0;
    var parY = 0;

    function frame() {
      /* TELEPHONE : tout est fige (Max, 02/09 nuit : « ne fait rien
         apparaitre, laisse tout fige sur mobile, c'est pas smooth
         sinon »). Meme sort que prefers-reduced-motion : aucun style pose,
         tout est simplement la. */
      if (mqr.matches || !mqd.matches) {
        clearAll();
        return;
      }
      var vh = window.innerHeight;
      var panel = wrap && (wrap.classList.contains('rv5-edition-on') || wrap.classList.contains('brt-panel-on'));

      /* 1 — L'ecriture du premier chapitre, partout. Le texte s'ecrit quand
         il monte vers le centre, s'efface quand il redescend. Une fenetre de
         sept mots glisse sur le texte : c'est elle qui donne le trace
         gauche → droite. */
      if ((chipEl || titleEl || words.length) && introEl) {
        /* LA COURSE, RECALEE (Max, 02/09 : « y'a pas d'animation magique sur
           ce texte »). Elle datait de la mise en page a UNE colonne, ou le
           recit vivait sous la paire, donc bas dans la scene. Depuis qu'il
           tient la colonne de droite, centre, son bord haut arrive bien plus
           tot : le texte finissait de s'ecrire alors que la scene 1 occupait
           encore tout l'ecran. On ecrivait dans le vide.

           La fenetre part donc de 80 % de l'ecran — l'intro est deja lisible,
           en bas — et s'acheve a 32 %, quand elle est posee. Tout le trace se
           voit. */
        var ri = introEl.getBoundingClientRect();
        /* L'ENTREE : monte comme avant, ne redescend jamais toute seule —
           `rise` continue de grimper tout le reste du scroll, sans plafond.
           C'est la SORTIE ci-dessous qui efface. */
        var rise = (vh * 0.80 - ri.top) / (vh * 0.48);
        var pEnter = clampN((rise - 0.10) / 0.90, 0, 1);
        /* UN TEMPS MORT (Max, 03/09 : « un poil plus tard »), un PALIER
           pose une fois l'entree finie, PUIS LA SORTIE (Max, 03/09,
           deuxieme tour : « l'ordre en disparition est inverse ! c'est
           d'abord L'histoire du tshirt puis siga siga qui doit
           disparaitre »). Un miroir dans le temps aurait efface le
           paragraphe en premier — l'inverse de ce qu'il fallait, et
           puisque son inversion n'arrivait qu'une fois toute la scene
           parcourue, l'ecran restait plein jusqu'a tres bas. Ici `hors`
           traverse les QUATRE MEMES fenetres dans le MEME ordre qu'a
           l'entree : le surtitre, entre le premier, sort le premier. */
        /* LE PALIER DU TEXTE ETAIT BON (Max, 03/09, troisieme tour : « le
           texte d'avant disparaissait bien, c'est l'image qui allait pas »)
           — remonte a 2,6 il ne redescendait plus du tout dans la longueur
           de scroll reelle de la page. Remis a sa valeur d'origine ; seul
           le palier du t-shirt 2, plus bas, bouge cette fois. */
        var PALIER = 1.3;
        var hors = clampN(1 - ((PALIER + 1) - rise), 0, 1);
        function etage(montre, efface) {
          return clampN(montre, 0, 1) * (1 - clampN(efface, 0, 1));
        }
        vagueBloc(chipEl, etage(pEnter / 0.28, hors / 0.28), 1);
        vagueBloc(titleEl, etage((pEnter - 0.14) / 0.32, (hors - 0.14) / 0.32), -1);
        vagueLettres(defL, etage((pEnter - 0.34) / 0.34, (hors - 0.34) / 0.34));
        vagueLettres(leadL, etage((pEnter - 0.52) / 0.48, (hors - 0.52) / 0.48));
      }

      /* 2 — Les chapitres detail, partout. */
      storyBits.forEach(chapterFocus);
      if (footEl) {
        var vf = vueAuCentre(footEl);
        if (vf >= 0.999) {
          clear(footEl);
        } else {
          footEl.style.opacity = String(vf.toFixed(3));
          footEl.style.transform = 'translateY(' + ((1 - vf) * 26).toFixed(1) + 'px)';
        }
      }

      /* 3 — Le morphing scene 1 → paire, mesure a chaque image. */
      if (albumScene && shotsEl) {
        /* 0,75 ecran de course : le passage vers la paire est plus vif
           (Max, 02/09 nuit : « le passage du debut doit etre un peu plus
           rapide »). */
        var t = albumScene.getBoundingClientRect().top;
        var q = clampN((vh - t) / (vh * 0.75), 0, 1);
        if (panel) q = 0;
        morphQ = q;
        /* Un survol devant/dos encore ouvert fausserait le fondu : le morph
           doit partir de la vue ACTIVE, celle que la paire met en premier. */
        if (q > 0.05 && clearPeek) clearPeek();
        /* Et si le visiteur regardait une photo PORTEE, la galerie revient
           au packshot des que le morph s'engage : c'est le t-shirt qui
           voyage vers la paire, pas une photo de plage (Max, 02/09 nuit). */
        if (q > 0.08 && shotIndex !== 0) showShot(0, true);

        /* LES BILLES D'IMAGE PARTENT AVEC LA SCENE 1 (Max, 02/09 : « quand on
           scrolle, les billes de l'image mockup doivent aussi disparaitre »).
           Elles comptent les vues du packshot : des que celui-ci s'en va vers
           la paire, elles n'ont plus rien a compter. Eteintes avant la
           moitie du trajet. */
        if (shotsNavEl) {
          var vn = 1 - clampN(q * 2.4, 0, 1);
          shotsNavEl.style.opacity = vn >= 0.999 ? '' : vn.toFixed(3);
          shotsNavEl.style.pointerEvents = vn < 0.06 ? 'none' : '';
        }

        var p1 = pairEl && pairEl.children[0];
        var p2 = pairEl && pairEl.children[1];

        if (q <= 0.003) {
          clear(shotsEl);
          shotsEl.style.transition = '';
          shotsEl.style.pointerEvents = '';
        } else {
          var pose = false;
          var actif = shotsEl.querySelector('.brt-shot.is-active img');
          if (p1 && actif) {
            /* Mesure a transform neutralise : la boite NATURELLE du
               packshot, la boite reelle de la vignette cible. */
            shotsEl.style.transition = 'none';
            shotsEl.style.transform = 'none';
            var a = actif.getBoundingClientRect();
            var b = p1.getBoundingClientRect();
            if (a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0) {
              var e = q < 0.5 ? 2 * q * q : 1 - Math.pow(-2 * q + 2, 2) / 2;
              var s = b.height / a.height;
              var dx = (b.left + b.width / 2 - a.left - a.width / 2) * e;
              var dy = (b.top + b.height / 2 - a.top - a.height / 2) * e;
              shotsEl.style.transform = 'translate3d(' + dx.toFixed(1) + 'px, ' + dy.toFixed(1) + 'px, 0) scale(' + (1 + (s - 1) * e).toFixed(4) + ')';
              pose = true;
            }
          }
          if (!pose) {
            /* Pas de cible mesurable (paire pas encore construite) : le
               geste approche, sans pretendre etre exact. */
            shotsEl.style.transition = 'none';
            shotsEl.style.transform = 'translateY(' + (q * 14).toFixed(2) + 'vh) scale(' + (1 - 0.48 * q).toFixed(3) + ')';
          }
          /* L'ECHANGE, tout a la fin et tres serre : tant que le packshot
             voyage, la vignette cible reste CACHEE — on ne voit jamais les
             deux (Max, 02/09 nuit : « tu peux masquer celle qu'elle
             remplace puisque maintenant on l'a »). Au moment ou il la
             recouvre exactement, ils s'echangent en six centiemes. Et le
             fantome ne doit plus intercepter les clics ni les survols. */
          shotsEl.style.opacity = String((1 - clampN((q - 0.93) / 0.06, 0, 1)).toFixed(3));
          shotsEl.style.pointerEvents = q > 0.5 ? 'none' : '';
        }

        if (p1) p1.style.opacity = String(clampN((q - 0.93) / 0.06, 0, 1).toFixed(3));

        /* ── LES DEUX VUES SE CROISENT (Max, 02/09 : « le t-shirt 2 plus
           grand et decale, a inverser en fonction du scroll ») ──
           Une fois la paire posee, les deux vues derivent en sens CONTRAIRE :
           celle du haut monte pendant que celle du bas descend, et le rapport
           s'inverse quand on repasse au-dessus. La course se lit sur la
           position de la scene par rapport au centre de l'ecran, donc elle
           est reversible et ne depend d'aucun minuteur.

           Le decalage ne touche jamais p1 tant que le morphing court : sa
           boite est la CIBLE de la mesure, et un transform la ferait mentir
           (d'ou le `q >= 1`). */
        var croise = 0;
        if (q >= 1) {
          var ra = albumScene.getBoundingClientRect();
          var na = (ra.top + ra.height / 2 - vh * 0.5) / (vh * 0.5);
          croise = clampN(na, -1, 1) * 22;
        }
        if (p1) p1.style.transform = croise ? 'translateY(' + croise.toFixed(1) + 'px)' : '';

        if (p2) {
          /* LE T-SHIRT 2 DOIT AUSSI DISPARAITRE (Max, 03/09), pas seulement
             apparaitre : `q` monte puis reste bloque a 1 pour tout le reste
             du scroll — bon pour le morphing, qui doit rester pose, mauvais
             ici puisque plus rien ne pouvait faire redescendre `a2`. Meme
             tente qu'ailleurs, batie sur `t` (qui continue de baisser, lui)
             plutot que sur `q` : ca monte comme avant, ca tient un instant,
             puis ca redescend. */
          /* LE PALIER DE CETTE IMAGE, ET ELLE SEULE (Max, 03/09, troisieme
             tour) : 1,2 disparaissait trop vite, 3,6 ne redescendait plus
             dans la longueur reelle de la page — l'entre-deux demande. */
          var riseQ = (vh - t) / (vh * 0.75);
          var qTent = clampN(Math.min(riseQ, 3.0 - riseQ), 0, 1);
          var a2 = clampN((qTent - 0.88) / 0.12, 0, 1);
          p2.style.opacity = String(a2.toFixed(3));
          p2.style.transform = 'translateX(' + ((1 - a2) * 30).toFixed(1) + 'px)'
            + ' translateY(' + (-croise).toFixed(1) + 'px)';
        }
      }

      /* 4 — La frise ne dépend plus du scroll pour AVANCER, mais elle
         s'efface tot quand on la quitte vers le recit (Max, 02/09 nuit :
         « la frise disparait pas assez tot ») — sans quoi elle se melait a
         la ligne de l'histoire. */
      frises.forEach(function (f) {
        var friseBox = f.box;
        var rf = friseBox.getBoundingClientRect();
        var normf = (rf.top + rf.height / 2 - vh * 0.5) / (vh * 0.5);
        /* LE FONDU N'EST PAS SYMETRIQUE, et c'est voulu. A L'ARRIVEE elle
           se remplit TOT (Max, 02/09 : « la frise doit apparaitre un peu
           plus vite ») : le plateau tient jusqu'a 0,62. AU DEPART elle
           s'efface TOT aussi (Max, 02/09 nuit : « la frise disparait pas
           assez tot ») : des 0,28, sans quoi elle se mele a la ligne de
           l'histoire. */
        var sortie = normf < 0;
        var plateau = sortie ? 0.42 : 0.72;
        var course = sortie ? 0.34 : 0.26;
        var vf2 = clampN(1 - Math.max(0, Math.abs(normf) - plateau) / course, 0, 1);
        var ovf = vf2 >= 0.999 ? '' : String(vf2.toFixed(3));
        friseBox.style.opacity = ovf;
        if (f.nav) f.nav.style.opacity = ovf;
      });

      /* 4 bis — le depart de la ligne : la boule et « Quelques infos »
         montent comme le pied de page. */
      /* En FONDU SEUL (Max, 05/09 : « le point se decale ») : le glissement
         de 20 px emportait la boule loin du depart de la ligne. */
      if (startEl) {
        var vs = vueAuCentre(startEl);
        if (vs >= 0.999) {
          clear(startEl);
        } else {
          startEl.style.opacity = String(vs.toFixed(3));
        }
      }

      /* 4 ter — LA LIGNE SE DESSINE (Max, 05/09 : « faut que l'animation
         suive »). Elle nait dans la boule et court jusqu'a la mi-hauteur de
         l'ecran, ni plus ni moins : `--brt-rail` est la part dessinee, le
         CSS l'applique en scaleY depuis le haut. La boule de fin s'allume
         sur les derniers pour cent. */
      if (railEl && startDot) {
        var rr = railEl.getBoundingClientRect();
        var rd = startDot.getBoundingClientRect();
        var depart = rd.top + rd.height / 2;
        var longueur = rr.bottom - depart;
        /* Deux tiers de l'ecran, pas la moitie : la ligne precede la
           lecture au lieu de la suivre (Max, 05/09 : « un peu de retard »). */
        var part = longueur > 0 ? clampN((vh * 0.68 - depart) / longueur, 0, 1) : 1;
        railEl.style.setProperty('--brt-rail', part.toFixed(4));
      }

      /* 5 — La parallaxe du packshot sous la souris. */
      if (stageEl) {
        if (panel || morphQ > 0.05 || !mqh.matches) {
          stageEl.style.transform = '';
        } else {
          stageEl.style.transform = 'translate(' + (parX * 10).toFixed(1) + 'px, ' + (parY * 8).toFixed(1) + 'px)';
        }
      }
    }

    var raf = false;
    function ask() {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        raf = false;
        frame();
      });
    }
    scrubNow = ask;

    if (wrap && stageEl) {
      wrap.addEventListener('mousemove', function (e) {
        if (!mqd.matches || !mqh.matches) return;
        var r = wrap.getBoundingClientRect();
        if (!r.width || !r.height) return;
        parX = clampN((e.clientX - r.left) / r.width * 2 - 1, -1, 1);
        parY = clampN((e.clientY - window.innerHeight * 0.5) / (window.innerHeight * 0.5), -1, 1);
        ask();
      });
      wrap.addEventListener('mouseleave', function () {
        parX = 0;
        parY = 0;
        ask();
      });
    }

    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask, { passive: true });
    if (mqd.addEventListener) {
      mqd.addEventListener('change', ask);
      mqr.addEventListener('change', ask);
    }
    frame();
  })();

  /* ══════════════════ 9. LES DEUX PANNEAUX NOIRS ══════════════════ */

  var grey = $('.product__media-wrapper');

  /** On peut ouvrir un panneau depuis la deuxieme scene : les panneaux vivent
   *  dans la premiere, il faut y remonter, sinon on ouvre quelque chose que
   *  personne ne voit. */
  function backToScene1() {
    /* Sur telephone, les panneaux sont des CARTES posees par-dessus la page
       (02/09 nuit) : plus besoin de remonter a la scene 1, on ouvre la ou
       on est. */
    if (mqMobile && mqMobile.matches) return;
    var scene = scene1();
    if (!scene) return;
    var box = scene.getBoundingClientRect();
    if (box.top < -40 || box.top > window.innerHeight * 0.4) {
      scene.scrollIntoView({ behavior: glisse(), block: 'start' });
    }
  }

  /* ── LE PANNEAU DE PRECOMMANDE : on l'observe, on ne le pilote pas ──
     bisou-fiche.js pose `.rv5-edition-on` sur la zone grise. C'est le seul
     contrat entre les deux fichiers, et il tient meme si l'un des deux ne se
     charge pas. */
  (function preorderPanel() {
    var holder = $('[data-brt-panel-video]');
    if (!grey) return;

    var video = holder ? holder.querySelector('video') : null;
    if (video) grey.classList.add('brt-has-video');

    function open() {
      backToScene1();
      if (!video) return;
      var src = video.getAttribute('data-src');
      if (src && !video.getAttribute('src')) video.setAttribute('src', src);
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* lecture refusee : l'affiche reste */ });
    }

    function close() {
      if (video && !video.paused) video.pause();
    }

    if (typeof MutationObserver === 'undefined') return;
    var was = false;
    new MutationObserver(function () {
      var now = grey.classList.contains('rv5-edition-on');
      if (now === was) return;
      was = now;
      if (now) {
        /* Les deux panneaux ne cohabitent pas : celui des tailles s'efface. */
        if (grey.classList.contains('brt-panel-on')) setSizePanel(false);
        open();
      } else {
        close();
      }
    }).observe(grey, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ── LE PANNEAU DU GUIDE DES TAILLES : celui-la est a nous ── */
  function setSizePanel(open) {
    var panel = document.getElementById('brt-size-panel');
    if (!panel || !grey) return;
    if (open) {
      /* On ferme l'autre par SON bouton : c'est bisou-fiche.js qui tient son
         etat, et lui court-circuiter la main laisserait le badge « ouvert ». */
      if (grey.classList.contains('rv5-edition-on')) {
        var c = root.querySelector('[data-rv5-edition-close]');
        if (c) c.click();
      }
      backToScene1();
    }
    grey.classList.toggle('brt-panel-on', open);
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      /* La ligne de la taille choisie se distingue : on ouvre le guide pour
         verifier SA taille, autant la lui montrer. */
      var marked = panel.querySelectorAll('[data-brt-size-row]');
      Array.prototype.forEach.call(marked, function (r) {
        r.classList.toggle('is-you', r.getAttribute('data-brt-size-row') === state.size);
      });
    }
    $$('.brt-size-link').forEach(function (l) {
      l.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      /* Deux croix, une par ecran : on donne le clavier a CELLE QUI EST
         AFFICHEE — `offsetParent` est nul sur un element en display:none. */
      var croix = panel.querySelectorAll('[data-brt-size-close]');
      for (var i = 0; i < croix.length; i++) {
        if (croix[i].offsetParent) { croix[i].focus(); break; }
      }
    }
  }

  (function sizePanel() {
    var panel = document.getElementById('brt-size-panel');
    if (!panel || !grey) return;

    $$('.brt-size-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        setSizePanel(!grey.classList.contains('brt-panel-on'));
      });
    });

    /* Par DELEGATION, et non sur une croix nommee : il y en a deux — celle
       du coin de l'ecran sur ordinateur, celle de la carte sur telephone —
       et un `querySelector` n'en aurait cable qu'une. */
    panel.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-brt-size-close]')) return;
      e.preventDefault();
      setSizePanel(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && grey.classList.contains('brt-panel-on')) setSizePanel(false);
    });
  })();

  /* ── SUR TELEPHONE, TAPER A COTE FERME ──
     Les panneaux y sont des fenetres centrees sur un voile (02/09 nuit :
     « impossible de quitter ») : un tap sur le voile — le panneau lui-meme,
     hors de sa carte — equivaut a la croix. */
  (function panelTapOut() {
    if (!mqMobile) return;
    $$('.rv5-edition-panel').forEach(function (p) {
      p.addEventListener('click', function (e) {
        /* TOUT CE QUI N'EST PAS LA CARTE FERME (Max, 02/09 : « si je clique
           a nouveau sur l'ecran ca ferme »). L'ancienne condition exigeait
           que le clic tombe pile sur le panneau lui-meme : des qu'il
           touchait un enfant decoratif — le voile, une marge du haut — il
           ne fermait rien. */
        if (!mqMobile.matches) return;
        if (!e.target.closest || e.target.closest('.rv5-edition-panel__inner')) return;
        if (p.id === 'brt-size-panel') {
          setSizePanel(false);
          return;
        }
        var c = p.querySelector('[data-rv5-edition-close]');
        if (c) c.click();
      });
    });
  })();

  /* ══════════════════ 10. LE COMPTE A REBOURS ══════════════════
     Il prend la place de « 10/10 RESTANTS » : ce qui s'epuise ici, ce n'est
     pas le stock, c'est le TEMPS. Le remplissage est le temps QUI RESTE —
     plein a l'ouverture, vide a la cloture — et le libelle descend du jour a
     l'heure puis a la minute a mesure qu'on approche.

     Le calcul se fait ici et non en Liquid parce qu'une page peut etre servie
     depuis un cache : `'now'` cote serveur peut avoir un jour de retard, et
     un compte a rebours faux vaut moins que pas de compte a rebours. Sans les
     deux dates, le bloc reste masque — on ne devine pas une echeance. */
  /* ── LA FRISE DES JOURS (Max, 03/09) ──
     Plus de barre qui se vide : une rangee de segments, UN PAR JOUR de
     precommande. Les jours passes sont pleins, le jour en cours se remplit au
     fil des heures (une variable CSS, --brt-fill, qu'on pousse toutes les
     trente secondes), les jours a venir sont vides. Le temps se consume a
     l'oeil, en continu.

     Le libelle suit l'urgence par paliers, et le compte a rebours lourd
     (« 12 j 15 h 31 min ») n'apparait plus que sur le dernier jour :
       ≥ 11 j  → PRECOMMANDE OUVERTE · X JOURS RESTANTS
       4–10 j  → PLUS QUE X JOURS
       2–3 j   → DERNIERS JOURS · X JOURS RESTANTS
       < 24 h  → DERNIER JOUR · XX H XX MIN
       < 6 h   → DERNIERES HEURES · XX H XX MIN
       fini    → PRECOMMANDE TERMINEE
     L'accent (--brt-heat, 0 → 1) se densifie avec l'echeance : l'or de la
     fiche, jamais un rouge d'alerte. */
  (function windowBar() {
    var box = $('[data-brt-window]');
    if (!box) return;

    /* Une date seule (`2026-09-08`) est interpretee en UTC par Date.parse.
       Pour une ouverture boutique, c'est bien le jour LOCAL du client qui
       compte : minuit a Paris doit rester minuit a Paris. */
    function parseLocalDay(value) {
      var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
      if (!match) return NaN;
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).getTime();
    }

    var openAt = parseLocalDay(CFG.window && CFG.window.openAt);
    var closeAt = parseLocalDay(CFG.window && CFG.window.closeAt);
    if (isNaN(openAt) || isNaN(closeAt) || closeAt <= openAt) return;

    var DAY = 24 * 60 * 60 * 1000;
    /* La cloture vaut la FIN du jour indique : « ferme le 22 » veut dire que
       le 22 au soir on peut encore commander. */
    closeAt += DAY - 1;

    var rail = box.querySelector('[data-brt-days]');
    var kicker = box.querySelector('[data-brt-window-kicker]');
    var text = box.querySelector('[data-brt-window-text]');

    /* Autant de segments que de jours dans la fenetre — vingt pour la saison
       8. Bornes de securite : un segment au moins, soixante au plus, sinon la
       rangee ne se lit plus. */
    var total = closeAt - openAt;
    var N = Math.max(1, Math.min(60, Math.round(total / DAY)));
    var segs = [];
    if (rail) {
      rail.textContent = '';
      for (var i = 0; i < N; i++) {
        var s = document.createElement('span');
        s.className = 'brt-days__seg';
        rail.appendChild(s);
        segs.push(s);
      }
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      var now = Date.now();
      var k = '';
      var main = '';
      var heat = 0;
      var done = 0;   /* nombre de jours entierement consommes */
      var frac = 0;   /* part ecoulee du jour en cours, 0 → 1 */
      var state = 'open';

      if (now < openAt) {
        state = 'soon';
        main = L.windowNotOpen || '';
      } else if (now > closeAt) {
        state = 'closed';
        done = N;
        heat = 1;
        main = L.windowClosed || '';
      } else {
        var gone = now - openAt;
        var left = closeAt - now;
        done = Math.min(N, Math.floor(gone / DAY));
        frac = (gone - done * DAY) / DAY;
        heat = Math.max(0, Math.min(1, gone / total));

        var dLeft = Math.max(1, Math.floor(left / DAY));
        k = L.windowOpenKicker || '';
        main = fill(L.windowDaysLeft || '{{ n }} jours restants', { n: dLeft });
      }

      for (var i = 0; i < segs.length; i++) {
        var sg = segs[i];
        var fillPct = i < done ? 1 : (i === done ? frac : 0);
        var v = fillPct >= 0.999 ? '1' : (fillPct <= 0.001 ? '0' : fillPct.toFixed(3));
        if (sg.__v !== v) {
          sg.__v = v;
          sg.style.setProperty('--brt-fill', v);
          sg.classList.toggle('is-past', i < done);
          sg.classList.toggle('is-now', i === done && state !== 'closed');
        }
      }
      if (rail && L.windowFriseAria) {
        rail.setAttribute('aria-label', fill(L.windowFriseAria, { i: Math.min(N, done + 1), n: N }));
      }

      box.style.setProperty('--brt-heat', heat.toFixed(3));
      /* La part consommee de la ligne : le CSS y fait courir un reflet, pour
         que la frise paraisse vivante (Max, 05/09). */
      box.style.setProperty('--brt-done', (N > 0 ? Math.min(1, (done + frac) / N) : 0).toFixed(4));
      box.setAttribute('data-brt-state', state);
      /* is-hot reste pour qui l'ecoute encore : les trois derniers jours. */
      box.classList.toggle('is-hot', state === 'lastdays' || state === 'lastday' || state === 'hours');
      if (kicker) {
        kicker.textContent = k;
        kicker.hidden = !k;
      }
      if (text) text.textContent = main;
    }

    tick();
    box.hidden = false;
    /* Trente secondes : assez pour que la minute affichee ne mente jamais de
       plus d'une demie, assez peu pour ne rien couter — et le jour en cours
       avance d'un trois-millieme a chaque fois, ce qui suffit a le voir
       bouger sur une journee. */
    setInterval(tick, 30000);
  })();

  /* ══════════════════ 10 bis. LES DEPLIANTS ET LES LIENS « EN SAVOIR PLUS » ══════════════════
     Chaque rangee de FABRICATION porte un chevron (Max, 03/09) : il ouvre
     l'explication juste dessous, et ARRETE le clic — sinon il remonterait a
     la rangee et changerait le mode d'achat. Les liens `data-brt-goto`
     descendent en douceur au manifeste (« intro ») ou au chapitre de la
     precommande (« preorder ») : rien ne s'ouvre ailleurs. */
  (function depliants() {
    $$('[data-brt-more]').forEach(function (btn) {
      var id = btn.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      var row = btn.closest('.brt-buy-row');
      if (!panel) return;
      function toggle(e) {
        e.preventDefault();
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        /* Une classe, pas `hidden` : le CSS anime la hauteur (grid 0fr → 1fr)
           et le contenu d'un seul bloc (Max, 05/09 : « plus smooth, comme un
           seul bloc pas deux »). */
        panel.classList.toggle('is-open', !open);
        if (row) row.classList.toggle('is-open', !open);
      }
      btn.addEventListener('click', toggle);
      /* Entree / Espace : le bouton natif clique deja, mais la rangee
         parente ecoute aussi le clavier — on coupe la remontee. */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') e.stopPropagation();
      });
    });

    function cible(quoi) {
      if (quoi === 'preorder') {
        /* Le chapitre coche « Cible du lien Details » dans l'editeur gagne
           (Max, 05/09) ; a defaut le preset precommande ; a defaut le recit. */
        return $('.brt-b__chapter[data-brt-detail-target]')
          || $('.brt-b__chapter[data-brt-preset="preorder"]')
          || $('.brt-scene--story')
          || null;
      }
      if (quoi === 'intro') {
        return $('[data-brt-intro]') || $('.brt-scene--album') || null;
      }
      return null;
    }

    $$('[data-brt-goto]').forEach(function (lien) {
      lien.addEventListener('click', function (e) {
        var el = cible(lien.getAttribute('data-brt-goto'));
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        var header = document.querySelector('.section-header, [data-header-section], sticky-header');
        var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
        var breathingRoom = window.matchMedia('(min-width: 900px)').matches ? 24 : 14;
        var top = window.pageYOffset + el.getBoundingClientRect().top - headerHeight - breathingRoom;
        window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: glisse() });
      });
    });
  })();

  /* ══════════════════ 11. LES FRAIS DE PORT OFFERTS — LE DEPLIANT ══════════════════
     Plus de fenetre (Max, 05/09). Au survol sur ordinateur (CSS), au toucher
     sur telephone (ici), la ligne ouvre deux cases rondes — etre connecte,
     avoir vote. Le Liquid a deja coche ce qui l'est ; ici on ouvre, on
     ferme, rien d'autre. */
  (function perk() {
    var roots = $$('[data-brt-perk]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      var btn = root.querySelector('.brt-perk2__btn');
      if (!btn) return;
      function poser(open) {
        root.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        poser(!root.classList.contains('is-open'));
      });
      /* Taper a cote ferme ; Echap aussi, et rend le focus au bouton. */
      document.addEventListener('click', function (e) {
        if (!root.classList.contains('is-open')) return;
        if (root.contains(e.target)) return;
        poser(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
        poser(false);
        btn.focus();
      });
    });
  })();

  /* ══════════════════ 12. PARTAGE ══════════════════ */
  $$('.rv5-btn-share').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
        }).catch(function () {});
      }
    });
  });

  /* ══════════════════ 13. MISE A JOUR GENERALE ══════════════════ */

  /** Le prix sur le bouton du panier suit l'etat — 39 € en precommande,
   *  49 € en stock. product-info.js le re-rend aussi depuis le serveur,
   *  mais son aller-retour peut tarder ou rater : on ecrit tout de suite ce
   *  qu'on sait, le serveur confirme derriere. */
  function refreshAtcPrice() {
    var v = findVariant(state);
    if (!v || !v.pf) return;
    $$('.bisou-atc-price').forEach(function (el) { el.textContent = v.pf; });
    refreshAtcLabel();
  }

  /** « PRECOMMANDER » en mode precommande, « COMMANDER » sinon (Max, 05/09).
   *  product-form.js reecrit le libelle depuis window.variantStrings.addToCart
   *  apres chaque ajout : on change AUSSI cette chaine, pour que le theme
   *  remette la notre et pas la sienne. Un bouton desactive (epuise) garde son
   *  texte a lui. */
  var preorderRow = $('[data-brt-preorder]');
  function refreshAtcLabel() {
    var isPre = preorderRow && state.mode === preorderRow.getAttribute('data-brt-mode');
    var label = isPre ? L.atcPreorder : L.atcOrder;
    if (!label) return;
    if (window.variantStrings) window.variantStrings.addToCart = label;
    $$('.bisou-atc-cell .product-form__submit').forEach(function (btn) {
      if (btn.hasAttribute('disabled')) return;
      var sp = btn.querySelector('span:not(.bisou-atc-price)');
      if (sp && sp.textContent.trim() !== label) sp.textContent = label;
    });
  }

  function refreshAll() {
    refreshBuyRows();
    refreshSizes();
    refreshColors();
    refreshAtcPrice();
  }

  refreshAll();
  showShotForColor();

  /* La fiche ouvre sur M / Blanc alors que le serveur a rendu sa premiere
     variante disponible — XS. Les cinq tailles valent le meme prix, l'ecart
     ne se voit pas ; mais le PANIER, lui, doit recevoir la bonne. On pose
     donc l'identifiant directement, sans emettre `change` : un aller-retour
     reseau au chargement pour une difference invisible serait du gaspillage. */
  (function poserVarianteInitiale() {
    var v = findVariant(state);
    if (!v) return;
    var sels = selects();
    if (OPT.mode != null && sels[OPT.mode]) setSelectValue(sels[OPT.mode], state.mode);
    if (OPT.size != null && sels[OPT.size]) setSelectValue(sels[OPT.size], state.size);
    if (OPT.color != null && sels[OPT.color]) setSelectValue(sels[OPT.color], state.color);
    writeFormVariantId(v.id, v.a);
  })();

  root.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.product-form__submit')) return;
    var v = findVariant(state);
    if (v) writeFormVariantId(v.id, v.a);
  }, true);

  root.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('form[action*="/cart/add"]')) return;
    var v = findVariant(state);
    if (v) writeFormVariantId(v.id, v.a);
  }, true);

  /* Le serveur a le dernier mot : si product-info.js re-rend une variante
     differente de celle qu'on croit tenir (rupture entre-temps, ?variant=
     dans l'URL), on se recale sur lui plutot que d'afficher un etat perime. */
  document.addEventListener('change', function (e) {
    if (pushing) return;
    if (!e.target.closest || !e.target.closest('variant-selects')) return;
    var sels = selects();
    var id = variantFromSelects(sels);
    if (!id) return;
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].id !== id) continue;
      if (OPT.mode != null) state.mode = VARIANTS[i].o[OPT.mode];
      if (OPT.size != null) state.size = VARIANTS[i].o[OPT.size];
      if (OPT.color != null) state.color = VARIANTS[i].o[OPT.color];
      refreshAll();
      return;
    }
  });
})();
